/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type ActionFunctionRuntime =
  | 'NODE20X'
  | 'NODE24X'
  | 'PYTHON39'
  | 'PYTHON314'
  | 'NODE16X'
  | 'NODE12X'
  | 'PYTHON36'
  | unhandledEnumCase;

export const ApiKeyAuthSettingsTypename =
  'com.hubspot.automation.actions.core.definition.webhook.auth.ApiKeyAuthSettings';
export const ApiKeyAuthSettingsDiscriminant = 'APIKEY';
export const ApiKeyAuthSettingsDiscriminantKey = 'authScheme';
export type ApiKeyAuthSettings = {
  apiKeySettings: ApiKeySettings;
  __typename: 'com.hubspot.automation.actions.core.definition.webhook.auth.ApiKeyAuthSettings';
} & { authScheme?: 'APIKEY' };

export const SignatureAuthSettingsTypename =
  'com.hubspot.automation.actions.core.definition.webhook.auth.SignatureAuthSettings';
export const SignatureAuthSettingsDiscriminant = 'SIGNED';
export const SignatureAuthSettingsDiscriminantKey = 'authScheme';
export type SignatureAuthSettings = {
  appId: number;
  __typename: 'com.hubspot.automation.actions.core.definition.webhook.auth.SignatureAuthSettings';
} & { authScheme?: 'SIGNED' };

export const WebhookAuthSettingsDiscriminantKey = 'authScheme';
export type WebhookAuthSettings = ApiKeyAuthSettings | SignatureAuthSettings;

export const JsonArraySchemaTypename =
  'com.hubspot.automation.actions.core.definition.webhook.body.JsonArraySchema';
export const JsonArraySchemaDiscriminant = 'ARRAY';
export const JsonArraySchemaDiscriminantKey = 'schemaType';
export type JsonArraySchema = {
  schemas: Default<JsonSchema[]>;
  __typename: 'com.hubspot.automation.actions.core.definition.webhook.body.JsonArraySchema';
} & { schemaType?: 'ARRAY' };

export const JsonLeafSchemaTypename =
  'com.hubspot.automation.actions.core.definition.webhook.body.JsonLeafSchema';
export const JsonLeafSchemaDiscriminant = 'LEAF';
export const JsonLeafSchemaDiscriminantKey = 'schemaType';
export type JsonLeafSchema = {
  variable: InputVariable;
  __typename: 'com.hubspot.automation.actions.core.definition.webhook.body.JsonLeafSchema';
} & { schemaType?: 'LEAF' };

export const JsonObjectSchemaTypename =
  'com.hubspot.automation.actions.core.definition.webhook.body.JsonObjectSchema';
export const JsonObjectSchemaDiscriminant = 'OBJECT';
export const JsonObjectSchemaDiscriminantKey = 'schemaType';
export type JsonObjectSchema = {
  children: Default<Record<string, JsonSchema>>;
  __typename: 'com.hubspot.automation.actions.core.definition.webhook.body.JsonObjectSchema';
} & { schemaType?: 'OBJECT' };

export const JsonSchemaDiscriminantKey = 'schemaType';
export type JsonSchema = JsonLeafSchema | JsonArraySchema | JsonObjectSchema;

export type WebhookQueryParams = { variables: Default<InputVariable[]> };

export namespace ComHubspotAutomationActionsCoreInstance {
  export type InstanceObjectRequestOptions = { properties: Default<string[]> };
}

export type ReferencedObjectProperty = {
  objectTypeId: string;
  propertyName: string;
};

export namespace ComHubspotAutomationDataPassingCoreModel {
  export type FieldTypeDefinition = {
    name: string;
    type: ComHubspotContactsDataContactsProtos.Type;
    label?: string;
    description?: string;
    fieldType?: PropertyFieldType;
    options: Default<Option[]>;
    optionsUrl?: string;
    referencedObjectType?: ObjectType;
    externalOptions: Default<boolean>;
    externalOptionsReferenceType?: string;
    dataSensitivity?: SensitivityLevel;
    sensitiveDataCategories: Default<SensitiveDataCategory[]>;
    fieldLevelPermission?: FieldLevelPermission;
    dateDisplayHint?: DateDisplayHint;
    referencedObjectTypeId?: string;
    readOnlyValue: Default<boolean>;
    isMultiValued: Default<boolean>;
    schema: Default<FieldSchema>;
  };
}

export namespace ComHubspotAutomationDataPassingCoreModelOutput {
  export type OutputFieldDefinition = {
    typeDefinition: ComHubspotAutomationDataPassingCoreModel.FieldTypeDefinition;
    globalOutput: Default<boolean>;
    referencedObjectProperty?: ReferencedObjectProperty;
  };
}

export type ActionTypeRule = {
  actionTypeId: string;
  restrictedToTriggerIds: Default<string[]>;
};

export const AgentInstanceTargetTypename =
  'com.hubspot.automation.embedded.models.AgentInstanceTarget';
export const AgentInstanceTargetDiscriminant = 'AGENT_INSTANCE';
export const AgentInstanceTargetDiscriminantKey = 'type';
/**
 *  {@link Target} variant scoping a request to an agent instance.
 *  <p>Resolves through CrmUsages rather than {@code FlowSearchRpc}; the id is string-backed so large
 *  CRM object ids survive the JavaScript number boundary.
 */
export type AgentInstanceTarget = {
  agentInstanceId: string;
  __typename: 'com.hubspot.automation.embedded.models.AgentInstanceTarget';
} & { type?: 'AGENT_INSTANCE' };

export type AiSettings = {
  generativeAiEnabled: boolean;
  copilotEnabled: Default<boolean>;
  crmPropertiesEnabled: Default<boolean>;
};

export type AutomationAccess = { roles: Default<AutomationRole[]> };

export type AutomationRole =
  | 'VIEW'
  | 'EDIT'
  | 'PUBLISH'
  | 'ENROLL'
  | 'DELETE'
  | unhandledEnumCase;

export type BuilderCompatibility =
  | 'SIDE_PANEL'
  | 'UNIFIED_BUILDER'
  | 'LEGACY_BUILDER'
  | 'PIPELINE_SETTINGS'
  | unhandledEnumCase;

export const CrmObjectTargetTypename =
  'com.hubspot.automation.embedded.models.CrmObjectTarget';
export const CrmObjectTargetDiscriminant = 'CRM_OBJECT';
export const CrmObjectTargetDiscriminantKey = 'type';
/**
 *  {@link Target} variant scoping a request to a CRM object type.
 *  <p>The {@code "0-1"}-style id deserializes straight into an {@link ObjectTypeId} via its
 *  single-value (de)serialization, so no manual parse step is required downstream.
 */
export type CrmObjectTarget = {
  objectTypeId: string;
  __typename: 'com.hubspot.automation.embedded.models.CrmObjectTarget';
} & { type?: 'CRM_OBJECT' };

/**
 * Virtual record for map with known enum keys
 */
export type EnumMapRelatedAutomationPermissionToPermissionAccess = {
  VIEW?: PermissionAccess;
  EDIT?: PermissionAccess;
  DELETE?: PermissionAccess;
  PUBLISH?: PermissionAccess;
  ENROLL?: PermissionAccess;
};

export type FetchAllowedActionTypesRequest = {};

export type FetchAllowedActionTypesResponse = {
  actionTypeIds: Default<string[]>;
  actionTypeRules: Default<ActionTypeRule[]>;
};

export type FetchAllowedTriggersRequest = {};

export type FetchAllowedTriggersResponse = { triggerIds: Default<string[]> };

export type FetchPermissionsRequest = {};

export type FetchPermissionsResponse = {
  aiSettings: AiSettings;
  automationAccess: AutomationAccess;
  accessibleObjectTypes: Default<string[]>;
};

export type FlowKind = 'MODERN' | 'HYBRID' | unhandledEnumCase;

export type GenerationStatus =
  | 'READY'
  | 'PENDING'
  | 'UNAVAILABLE'
  | 'TERMINAL_FALLBACK'
  | unhandledEnumCase;

export type PermissionAccess = {
  hasAccess: boolean;
  requiredScopes: Default<string[]>;
  requiredProperties: Default<RequiredProperty[]>;
  requiredTeamIds: Default<number[]>;
  restrictedMultiAccountFlow: Default<boolean>;
};

export const RecommendedAutomationDiscriminantKey = 'type';
export type RecommendedAutomation = RecommendedAutomationTemplate;

export const RecommendedAutomationTemplateTypename =
  'com.hubspot.automation.embedded.models.RecommendedAutomationTemplate';
export const RecommendedAutomationTemplateDiscriminant = 'TEMPLATE';
export const RecommendedAutomationTemplateDiscriminantKey = 'type';
export type RecommendedAutomationTemplate = {
  templateId: number;
  name: string;
  shortDescription: string;
  illustration?: string;
  updatedAt?: number;
  __typename: 'com.hubspot.automation.embedded.models.RecommendedAutomationTemplate';
} & { type?: 'TEMPLATE' };

export type RecommendedAutomationType = 'TEMPLATE' | unhandledEnumCase;

export const RelatedAutomationDiscriminantKey = 'type';
export type RelatedAutomation = RelatedWorkflow | RelatedHybridFlow;

export type RelatedAutomationAccess = {
  permissions: Default<EnumMapRelatedAutomationPermissionToPermissionAccess>;
};

export type RelatedAutomationType =
  | 'WORKFLOW'
  | 'HYBRID_FLOW'
  | unhandledEnumCase;

export const RelatedHybridFlowTypename =
  'com.hubspot.automation.embedded.models.RelatedHybridFlow';
export const RelatedHybridFlowDiscriminant = 'HYBRID_FLOW';
export const RelatedHybridFlowDiscriminantKey = 'type';
export type RelatedHybridFlow = {
  flowId: number;
  name?: string;
  description?: string;
  enabled: boolean;
  sourceApp: SourceApp;
  totalEnrolled?: number;
  currentlyEnrolled?: number;
  access: RelatedAutomationAccess;
  flowUuid?: string;
  compatibleBuilders: Default<BuilderCompatibility[]>;
  link?: WorkflowLink;
  __typename: 'com.hubspot.automation.embedded.models.RelatedHybridFlow';
} & { type?: 'HYBRID_FLOW' };

export const RelatedWorkflowTypename =
  'com.hubspot.automation.embedded.models.RelatedWorkflow';
export const RelatedWorkflowDiscriminant = 'WORKFLOW';
export const RelatedWorkflowDiscriminantKey = 'type';
export type RelatedWorkflow = {
  flowId: number;
  name?: string;
  description?: string;
  enabled: boolean;
  sourceApp: SourceApp;
  totalEnrolled?: number;
  currentlyEnrolled?: number;
  access: RelatedAutomationAccess;
  flowUuid?: string;
  compatibleBuilders: Default<BuilderCompatibility[]>;
  link?: WorkflowLink;
  __typename: 'com.hubspot.automation.embedded.models.RelatedWorkflow';
} & { type?: 'WORKFLOW' };

export type RequiredProperty = { objectTypeId: string; propertyName: string };

export type ResolveWorkflowLinksRequest = {
  flowIds: Default<number[]>;
  baseUrl?: string;
};

export type ResolveWorkflowLinksResponse = { links: Default<WorkflowLink[]> };

export type RoutingDestination =
  | 'UNIFIED_BUILDER'
  | 'LEGACY_BUILDER'
  | 'SIDE_PANEL'
  | 'NONE'
  | unhandledEnumCase;

export type SortDirection = 'ASC' | 'DESC' | unhandledEnumCase;

export type SuggestedAutomation = {
  suggestionId: string;
  insightText?: string;
  displayText: string;
  /** @deprecated superseded by instantiation() — true iff the card is actionable (instantiation is TEMPLATE or DOCUMENT). Kept for wire compatibility; remove in a follow-up once no client reads it. */
  hasWorkflowDocument: boolean;
  templateId?: number;
  workflowDocument?: string;
  workflowTemplatePreview?: string;
  instantiation?: SuggestionInstantiation;
};

export type SuggestionInstantiation =
  | 'TEMPLATE'
  | 'DOCUMENT'
  | unhandledEnumCase;

export type SuggestionsFailureReason =
  | 'NO_OBJECT_READ_ACCESS'
  | 'GENERATION_ERROR'
  | 'SERVICE_UNAVAILABLE'
  | 'GENERATIVE_AI_DISABLED'
  | 'TARGET_NOT_SUPPORTED'
  | unhandledEnumCase;

export const TargetDiscriminantKey = 'type';
export type Target = CrmObjectTarget | AgentInstanceTarget;

export type TemplateListing = {
  templateId: number;
  name: string;
  shortDescription: string;
  illustration?: string;
  tags: Default<string[]>;
  updatedAt?: number;
  workflowTemplatePreview?: string;
  slug?: string;
};

export type TemplateSortBy = 'NAME' | 'UPDATED_AT' | unhandledEnumCase;

export type WorkflowLink = {
  flowId: number;
  destination: RoutingDestination;
  path?: string;
  name?: string;
  sourceApp?: SourceApp;
  flowUuid?: string;
};

export type WorkflowUsage = { currentCount: number; limit?: number };

/**
 *  Typed pagination cursor for {@code fetchAllAutomations}.
 *  <p>The portal-wide list is always workflow-recency keyset-ordered, so — unlike the related-
 *  automations cursor — there is only ever a {@link FlowKeyset} resume position; there is no
 *  agent-instance page-token variant. Carries the filter/sort snapshot the page sequence was started
 *  with so a cursor replayed against conflicting explicit filters is rejected
 *  ({@code CURSOR_FILTER_MISMATCH}). An empty cursor (no {@link #position()}) is the first-page
 *  request and is the {@code getOffset()} default on the request.
 */
export type AllAutomationsCursor = {
  flowKinds: Default<FlowKind[]>;
  sourceApps: Default<SourceApp[]>;
  compatibleBuilders: Default<BuilderCompatibility[]>;
  sortDirection?: SortDirection;
  position?: FlowKeyset;
};

/**
 *  Request for {@code fetchAllAutomations}: a page of the portal-wide workflow list, not scoped to any
 *  target. Optionally filtered by flow kind, source app, and builder compatibility, and sortable.
 *  Paginated via {@link ChirpPagedRequest}; the first-page request carries the default empty
 *  {@link AllAutomationsCursor}.
 */
export type FetchAllAutomationsRequest = {
  flowKinds: Default<FlowKind[]>;
  sourceApps: Default<SourceApp[]>;
  compatibleBuilders: Default<BuilderCompatibility[]>;
  sortDirection?: SortDirection;
  pageLength: Default<number>;
  offset: Default<AllAutomationsCursor>;
};

/**
 *  Response for {@code fetchAllAutomations}: a page of the portal-wide automation list plus the
 *  next-page cursor. Reuses the v1 {@code RelatedAutomation} element type; only the native
 *  {@link ChirpPagedResponse} envelope over a typed {@link AllAutomationsCursor} is new.
 */
export type FetchAllAutomationsResponse = {
  results: Default<RelatedAutomation[]>;
  hasMore: boolean;
  offset: AllAutomationsCursor;
};

/**
 *  Request for {@code fetchEmbeddedSummary}: the panel's single initial-load call for a
 *  {@link Target}.
 *  <p>Only a {@link CrmObjectTarget} is supported today; other target variants are rejected with
 *  {@code TARGET_TYPE_UNSUPPORTED}. The optional first-page sizes (default 100 each, max 100) size the
 *  related and portal-wide automation lists folded into the response.
 */
export type FetchEmbeddedSummaryRequest = {
  target: Target;
  relatedAutomationsPageSize?: number;
  allAutomationsPageSize?: number;
};

/**
 *  Response for {@code fetchEmbeddedSummary}: the panel's whole initial load in one round trip.
 *  <p>Differs from v1 only in the two automation lists: instead of v1's flat
 *  {@code relatedAutomations}/{@code hasMore}/{@code nextCursor} fields, both the related and the new
 *  portal-wide list are returned as their native {@link ChirpPagedResponse}-shaped types
 *  ({@link FetchRelatedAutomationsResponse}, {@link FetchAllAutomationsResponse}) carrying a typed
 *  cursor. To page further, the frontend hands a list's cursor to {@code fetchRelatedAutomations} or
 *  {@code fetchAllAutomations}. Everything else (recommended templates, AI settings, automation
 *  access, suggested automations, workflow usage) is reused from v1 unchanged.
 */
export type FetchEmbeddedSummaryResponse = {
  recommendedAutomations: Default<RecommendedAutomation[]>;
  relatedAutomations: FetchRelatedAutomationsResponse;
  allAutomations: FetchAllAutomationsResponse;
  aiSettings: AiSettings;
  automationAccess: AutomationAccess;
  suggestedAutomations: Default<SuggestedAutomation[]>;
  suggestedAutomationsStatus: GenerationStatus;
  suggestedAutomationsFailureReason?: SuggestionsFailureReason;
  workflowUsage?: WorkflowUsage;
};

/**
 *  Request for {@code fetchRelatedAutomations}: a page of automations related to a {@link Target}.
 *  <p>The {@code target} selects the backend ({@code CRM_OBJECT} → workflow index, {@code
 *  AGENT_INSTANCE} → CrmUsages). Filters and sort are optional; an empty set means "no filter on that
 *  dimension" and resolves to the service defaults. Paginated via {@link ChirpPagedRequest}: the
 *  first-page request carries the default empty {@link RelatedAutomationsCursor}, and subsequent
 *  pages carry the cursor from the prior response.
 */
export type FetchRelatedAutomationsRequest = {
  target: Target;
  flowKinds: Default<FlowKind[]>;
  sourceApps: Default<SourceApp[]>;
  compatibleBuilders: Default<BuilderCompatibility[]>;
  sortDirection?: SortDirection;
  pageLength: Default<number>;
  offset: Default<RelatedAutomationsCursor>;
};

/**
 *  Response for {@code fetchRelatedAutomations}: a page of related automations plus the next-page
 *  cursor. The result element type is the same {@code RelatedAutomation} used by v1; only the
 *  pagination envelope (native {@link ChirpPagedResponse} over a typed
 *  {@link RelatedAutomationsCursor}) is new.
 */
export type FetchRelatedAutomationsResponse = {
  results: Default<RelatedAutomation[]>;
  hasMore: boolean;
  offset: RelatedAutomationsCursor;
};

/**
 *  Typed pagination cursor for {@code fetchTemplates}.
 *  <p>The upstream template catalog is paged by a numeric {@link #offset()}, mirroring v1's
 *  offset-only template cursor. An empty cursor (no {@link #offset()}) is the first-page request and
 *  is the {@code getOffset()} default on the request. Deliberately carries no filter/target snapshot:
 *  v1's template cursor carried none and applied no cursor/request mismatch guard, so v2 stays at
 *  parity rather than introducing a guard v1 never had.
 */
export type FetchTemplatesCursor = { offset?: number };

/**
 *  Request for {@code fetchTemplates}: a page of automation templates compatible with a
 *  {@link Target}.
 *  <p>A {@link CrmObjectTarget} is scoped to the target's CRM object type and intersected with the
 *  embedded-panel compatibility cache; an {@code AGENT_INSTANCE} target is scoped to templates
 *  tagged with the {@code "agentic"} internal tag. Other target variants are rejected with
 *  {@code TARGET_TYPE_UNSUPPORTED}. Narrowable by an optional full-text {@code search} string and/or
 *  {@code tags}, and sortable by name or last-updated date. Paginated via {@link ChirpPagedRequest};
 *  the first-page request carries the default empty {@link FetchTemplatesCursor}.
 */
export type FetchTemplatesRequest = {
  target: Target;
  search?: string;
  tags: Default<string[]>;
  sortBy?: TemplateSortBy;
  sortDirection?: SortDirection;
  pageLength: Default<number>;
  offset: Default<FetchTemplatesCursor>;
};

/**
 *  Response for {@code fetchTemplates}: a page of matching template listings plus the next-page
 *  cursor. Reuses the v1 {@code TemplateListing} element type; only the native
 *  {@link ChirpPagedResponse} envelope over a typed {@link FetchTemplatesCursor} is new.
 */
export type FetchTemplatesResponse = {
  results: Default<TemplateListing[]>;
  hasMore: boolean;
  offset: FetchTemplatesCursor;
};

/**
 *  Request for the {@code fetchWorkflow} deep-link endpoint: a single flow id. The portal id comes
 *  from the CHIRP context.
 */
export type FetchWorkflowRequest = { flowId: number };

/**
 *  Bundle a directly-opened (deep-linked) workflow needs to render without a second call.
 *  <p>Returns the workflow model, the caller's resolved access, the builders the flow can be opened
 *  in, and a resolved link — so the panel can route a directly-opened workflow to the correct
 *  destination from this one call without a second RPC to {@code resolveWorkflowLinks}. The link
 *  matches what {@code resolveWorkflowLinks} would return when called without an in-context
 *  {@code baseUrl}; the in-context side-panel URL variant is not needed here because the side panel
 *  is already the in-context surface.
 */
export type FetchWorkflowResponse = {
  workflow: WorkflowResponse;
  access: RelatedAutomationAccess;
  compatibleBuilders: Default<BuilderCompatibility[]>;
  workflowLink?: WorkflowLink;
};

/**
 *  Keyset resume position for the workflow-recency ordered list endpoints
 *  ({@code fetchRelatedAutomations} for CRM object targets, {@code fetchAllAutomations}).
 *  <p>Carries the {@code (flowUpdatedAt, flowId)} of the last row returned on the prior page; the
 *  next page resumes strictly after it. A first-page cursor carries no keyset, so this is nested as
 *  an {@code Optional} on the cursor types that use it — its presence is what distinguishes a
 *  resume request from a first-page request.
 */
export type FlowKeyset = { flowUpdatedAt: number; flowId: number };

/**
 *  Typed pagination cursor for {@code fetchRelatedAutomations}.
 *  <p>Modeled rather than opaque: the frontend still treats it as opaque (it only echoes the value
 *  back), but the shape is a real CHIRP message so the resume position is inspectable and
 *  type-checked server-side. An empty cursor (no {@link #position()}) is the first-page request; it is
 *  the {@code getOffset()} default on the request.
 *  <p>The cursor carries the filter/sort snapshot the page sequence was started with
 *  ({@link #flowKinds()}, {@link #sourceApps()}, {@link #compatibleBuilders()},
 *  {@link #sortDirection()}) so the service can reject a cursor replayed against conflicting explicit
 *  filters ({@code CURSOR_FILTER_MISMATCH}), plus the {@code (flowUpdatedAt, flowId)} keyset resume
 *  position ({@link #position()}). Both CRM-object and agent-instance targets page the workflow index
 *  in recency order, so both use the same keyset.
 */
export type RelatedAutomationsCursor = {
  flowKinds: Default<FlowKind[]>;
  sourceApps: Default<SourceApp[]>;
  compatibleBuilders: Default<BuilderCompatibility[]>;
  sortDirection?: SortDirection;
  position?: FlowKeyset;
};

/**
 *  Typed pagination cursor for {@code searchRelatedAutomations}.
 *  <p>Live Flow search is offset-paginated, so the resume position is a numeric {@link #offset()}
 *  rather than a keyset. Carries the target's {@link #objectTypeId()} plus the search query and
 *  filter/sort snapshot the page sequence was started with, so a cursor replayed against a
 *  conflicting target or explicit fields is rejected ({@code CURSOR_FILTER_MISMATCH}) rather than
 *  resuming a different search at a stale offset. An empty cursor (no {@link #offset()}) is the
 *  first-page request and is the {@code getOffset()} default on the request.
 */
export type SearchRelatedAutomationsCursor = {
  objectTypeId?: string;
  searchQuery?: string;
  flowKinds: Default<FlowKind[]>;
  sourceApps: Default<SourceApp[]>;
  compatibleBuilders: Default<BuilderCompatibility[]>;
  sortDirection?: SortDirection;
  offset?: number;
};

/**
 *  Request for {@code searchRelatedAutomations}: a page of automations related to a {@link Target},
 *  found via live Flow search.
 *  <p>Only a {@link CrmObjectTarget} is supported today; other target variants are rejected with
 *  {@code TARGET_TYPE_UNSUPPORTED}. Optionally narrowed by {@code searchQuery} over the workflow name
 *  and filterable by flow kind, source app, and builder compatibility. Paginated via
 *  {@link ChirpPagedRequest}; the first-page request carries the default empty
 *  {@link SearchRelatedAutomationsCursor}.
 */
export type SearchRelatedAutomationsRequest = {
  target: Target;
  searchQuery?: string;
  flowKinds: Default<FlowKind[]>;
  sourceApps: Default<SourceApp[]>;
  compatibleBuilders: Default<BuilderCompatibility[]>;
  sortDirection?: SortDirection;
  pageLength: Default<number>;
  offset: Default<SearchRelatedAutomationsCursor>;
};

/**
 *  Response for {@code searchRelatedAutomations}: a page of related automations (with builder
 *  compatibility) plus the next-page cursor. Reuses the v1 {@code RelatedAutomation} element type;
 *  only the native {@link ChirpPagedResponse} envelope over a typed
 *  {@link SearchRelatedAutomationsCursor} is new.
 */
export type SearchRelatedAutomationsResponse = {
  results: Default<RelatedAutomation[]>;
  hasMore: boolean;
  offset: SearchRelatedAutomationsCursor;
};

export type ResolveWorkflowLinksError = {
  chirpErrorMessage: Default<string>;
  errorType: ComHubspotAutomationEmbeddedRpcAbstractResolveWorkflowLinksError.ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export namespace ComHubspotAutomationEmbeddedRpcAbstractResolveWorkflowLinksError {
  export type ErrorType =
    | 'PORTAL_ID_MISSING'
    | 'INVALID_BASE_URL'
    | unhandledEnumCase;
}

export type FetchAllAutomationsError = {
  chirpErrorMessage: Default<string>;
  errorType: ComHubspotAutomationEmbeddedRpcV2AbstractFetchAllAutomationsError.ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type FetchEmbeddedSummaryError = {
  chirpErrorMessage: Default<string>;
  errorType: ComHubspotAutomationEmbeddedRpcV2AbstractFetchEmbeddedSummaryError.ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type FetchRelatedAutomationsError = {
  chirpErrorMessage: Default<string>;
  errorType: ComHubspotAutomationEmbeddedRpcV2AbstractFetchRelatedAutomationsError.ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type FetchTemplatesError = {
  chirpErrorMessage: Default<string>;
  errorType: ComHubspotAutomationEmbeddedRpcV2AbstractFetchTemplatesError.ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type FetchWorkflowError = {
  chirpErrorMessage: Default<string>;
  errorType: ComHubspotAutomationEmbeddedRpcV2AbstractFetchWorkflowError.ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type SearchRelatedAutomationsError = {
  chirpErrorMessage: Default<string>;
  errorType: ComHubspotAutomationEmbeddedRpcV2AbstractSearchRelatedAutomationsError.ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export namespace ComHubspotAutomationEmbeddedRpcV2AbstractFetchAllAutomationsError {
  export type ErrorType =
    | 'PORTAL_ID_MISSING'
    | 'CURSOR_FILTER_MISMATCH'
    | 'CURSOR_INVALID'
    | 'INVALID_PAGE_SIZE'
    | unhandledEnumCase;
}

export namespace ComHubspotAutomationEmbeddedRpcV2AbstractFetchEmbeddedSummaryError {
  export type ErrorType =
    | 'PORTAL_ID_MISSING'
    | 'OBJECT_TYPE_ACCESS_DENIED'
    | 'AGENT_INSTANCE_ACCESS_DENIED'
    | 'TARGET_TYPE_UNSUPPORTED'
    | 'INVALID_PAGE_SIZE'
    | 'INVALID_TARGET_ID'
    | unhandledEnumCase;
}

export namespace ComHubspotAutomationEmbeddedRpcV2AbstractFetchRelatedAutomationsError {
  export type ErrorType =
    | 'PORTAL_ID_MISSING'
    | 'OBJECT_TYPE_ACCESS_DENIED'
    | 'AGENT_INSTANCE_ACCESS_DENIED'
    | 'TARGET_TYPE_UNSUPPORTED'
    | 'CURSOR_FILTER_MISMATCH'
    | 'INVALID_PAGE_SIZE'
    | 'INVALID_TARGET_ID'
    | unhandledEnumCase;
}

export namespace ComHubspotAutomationEmbeddedRpcV2AbstractFetchTemplatesError {
  export type ErrorType =
    | 'PORTAL_ID_MISSING'
    | 'OBJECT_TYPE_ACCESS_DENIED'
    | 'TARGET_TYPE_UNSUPPORTED'
    | 'INVALID_PAGE_SIZE'
    | unhandledEnumCase;
}

export namespace ComHubspotAutomationEmbeddedRpcV2AbstractFetchWorkflowError {
  export type ErrorType =
    | 'PORTAL_ID_MISSING'
    | 'WORKFLOW_NOT_FOUND'
    | 'WORKFLOW_ACCESS_DENIED'
    | unhandledEnumCase;
}

export namespace ComHubspotAutomationEmbeddedRpcV2AbstractSearchRelatedAutomationsError {
  export type ErrorType =
    | 'PORTAL_ID_MISSING'
    | 'OBJECT_TYPE_ACCESS_DENIED'
    | 'TARGET_TYPE_UNSUPPORTED'
    | 'CURSOR_FILTER_MISMATCH'
    | 'INVALID_PAGE_SIZE'
    | 'INVALID_SEARCH_QUERY'
    | unhandledEnumCase;
}

export type ObjectProperty = {
  propertyName: string;
  isRequired: Default<boolean>;
};

export type ExtensionInstanceFields = {
  extensionDefinitionId: number;
  actionTypeId?: string;
  extensionDefinitionVersion: number;
  fields: Default<HydratedField[]>;
  objectRequestOptions: Default<ComHubspotAutomationExtensionsV2CoreInstance.InstanceObjectRequestOptions>;
};

export type HydratedField = {
  fieldKey: string;
  fieldValue: ValueCore;
  inputActionName: Default<string>;
};

export namespace ComHubspotAutomationExtensionsV2CoreInstance {
  export type InstanceObjectRequestOptions = {
    properties: Default<ObjectProperty[]>;
  };
}

export const ExternalDataValueTypename =
  'com.hubspot.automation.extensions.v2.core.instance.values.ExternalDataValue';
export const ExternalDataValueDiscriminant = 'EXTERNAL';
export const ExternalDataValueDiscriminantKey = 'valueType';
export type ExternalDataValue = {
  value: string;
  __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.ExternalDataValue';
} & { valueType?: 'EXTERNAL' };

export type InstanceValueType =
  | 'SINGLE'
  | 'MULTI'
  | 'PROPERTY'
  | 'STATIC'
  | 'EXTERNAL'
  | 'FIELD_DATA'
  | 'FETCHED_OBJECT_PROPERTY'
  | 'OBJECT_COORDINATES_PROVIDER'
  | 'SINGLE_OBJECT_COORDINATES'
  | 'ENROLLMENT_EVENT_PROPERTY'
  | 'ENROLLMENT_DATASET_COLUMN'
  | 'ACTION_OUTPUT_OBJECT_PROPERTY'
  | 'LIST'
  | 'MAP'
  | 'TIMESTAMP'
  | 'TEMPLATE'
  | 'RELATIVE_DATETIME'
  | unhandledEnumCase;

export const ListValueTypename =
  'com.hubspot.automation.extensions.v2.core.instance.values.ListValue';
export const ListValueDiscriminant = 'LIST';
export const ListValueDiscriminantKey = 'valueType';
export type ListValue = {
  values: Default<ValueCore[]>;
  __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.ListValue';
} & { valueType?: 'LIST' };

export const MapValueTypename =
  'com.hubspot.automation.extensions.v2.core.instance.values.MapValue';
export const MapValueDiscriminant = 'MAP';
export const MapValueDiscriminantKey = 'valueType';
export type MapValue = {
  values: Default<Record<string, ValueCore>>;
  __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.MapValue';
} & { valueType?: 'MAP' };

export const SingleValueTypename =
  'com.hubspot.automation.extensions.v2.core.instance.values.SingleValue';
export const SingleValueDiscriminant = 'SINGLE';
export const SingleValueDiscriminantKey = 'valueType';
export type SingleValue = {
  value: string;
  __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.SingleValue';
} & { valueType?: 'SINGLE' };

export const ValueCoreDiscriminantKey = 'valueType';
export type ValueCore =
  | SingleValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.MultiValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.ObjectPropertyValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.StaticValue
  | ExternalDataValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.FieldDataValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.FetchedObjectPropertyValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.ObjectCoordinatesProviderValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.SingleObjectCoordinatesValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.EnrollmentEventPropertyValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.EnrollmentDatasetColumnValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.ActionOutputObjectPropertyValue
  | ListValue
  | MapValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.TimestampValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.TemplateValue
  | ComHubspotAutomationExtensionsV2CoreInstanceValues.RelativeDateTimeValue;

export namespace ComHubspotAutomationExtensionsV2CoreInstanceValues {
  export const ActionOutputObjectPropertyValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.ActionOutputObjectPropertyValue';
  export const ActionOutputObjectPropertyValueDiscriminant =
    'ACTION_OUTPUT_OBJECT_PROPERTY';
  export const ActionOutputObjectPropertyValueDiscriminantKey = 'valueType';
  export type ActionOutputObjectPropertyValue = {
    propertyToken: string;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.ActionOutputObjectPropertyValue';
  } & { valueType?: 'ACTION_OUTPUT_OBJECT_PROPERTY' };

  export const EnrollmentDatasetColumnValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.EnrollmentDatasetColumnValue';
  export const EnrollmentDatasetColumnValueDiscriminant =
    'ENROLLMENT_DATASET_COLUMN';
  export const EnrollmentDatasetColumnValueDiscriminantKey = 'valueType';
  export type EnrollmentDatasetColumnValue = {
    propertyToken: string;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.EnrollmentDatasetColumnValue';
  } & { valueType?: 'ENROLLMENT_DATASET_COLUMN' };

  export const EnrollmentEventPropertyValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.EnrollmentEventPropertyValue';
  export const EnrollmentEventPropertyValueDiscriminant =
    'ENROLLMENT_EVENT_PROPERTY';
  export const EnrollmentEventPropertyValueDiscriminantKey = 'valueType';
  export type EnrollmentEventPropertyValue = {
    propertyToken: string;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.EnrollmentEventPropertyValue';
  } & { valueType?: 'ENROLLMENT_EVENT_PROPERTY' };

  export const FetchedObjectPropertyValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.FetchedObjectPropertyValue';
  export const FetchedObjectPropertyValueDiscriminant =
    'FETCHED_OBJECT_PROPERTY';
  export const FetchedObjectPropertyValueDiscriminantKey = 'valueType';
  export type FetchedObjectPropertyValue = {
    propertyToken: string;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.FetchedObjectPropertyValue';
  } & { valueType?: 'FETCHED_OBJECT_PROPERTY' };

  export const FieldDataValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.FieldDataValue';
  export const FieldDataValueDiscriminant = 'FIELD_DATA';
  export const FieldDataValueDiscriminantKey = 'valueType';
  export type FieldDataValue = {
    fieldDataIdentifier: FieldDataIdentifier;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.FieldDataValue';
  } & { valueType?: 'FIELD_DATA' };

  export const MultiValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.MultiValue';
  export const MultiValueDiscriminant = 'MULTI';
  export const MultiValueDiscriminantKey = 'valueType';
  export type MultiValue = {
    value: Default<string[]>;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.MultiValue';
  } & { valueType?: 'MULTI' };

  export const ObjectCoordinatesProviderValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.ObjectCoordinatesProviderValue';
  export const ObjectCoordinatesProviderValueDiscriminant =
    'OBJECT_COORDINATES_PROVIDER';
  export const ObjectCoordinatesProviderValueDiscriminantKey = 'valueType';
  export type ObjectCoordinatesProviderValue = {
    source: DataSourceType;
    sourceId?: number;
    fieldName?: string;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.ObjectCoordinatesProviderValue';
  } & { valueType?: 'OBJECT_COORDINATES_PROVIDER' };

  export const ObjectPropertyValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.ObjectPropertyValue';
  export const ObjectPropertyValueDiscriminant = 'PROPERTY';
  export const ObjectPropertyValueDiscriminantKey = 'valueType';
  export type ObjectPropertyValue = {
    propertyName: string;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.ObjectPropertyValue';
  } & { valueType?: 'PROPERTY' };

  export const RelativeDateTimeValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.RelativeDateTimeValue';
  export const RelativeDateTimeValueDiscriminant = 'RELATIVE_DATETIME';
  export const RelativeDateTimeValueDiscriminantKey = 'valueType';
  export type RelativeDateTimeValue = {
    timeDelay: TimeDelay;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.RelativeDateTimeValue';
  } & { valueType?: 'RELATIVE_DATETIME' };

  export const SingleObjectCoordinatesValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.SingleObjectCoordinatesValue';
  export const SingleObjectCoordinatesValueDiscriminant =
    'SINGLE_OBJECT_COORDINATES';
  export const SingleObjectCoordinatesValueDiscriminantKey = 'valueType';
  export type SingleObjectCoordinatesValue = {
    coordinatesToken: string;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.SingleObjectCoordinatesValue';
  } & { valueType?: 'SINGLE_OBJECT_COORDINATES' };

  export const StaticValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.StaticValue';
  export const StaticValueDiscriminant = 'STATIC';
  export const StaticValueDiscriminantKey = 'valueType';
  export type StaticValue = {
    value: string;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.StaticValue';
  } & { valueType?: 'STATIC' };

  export const TemplateValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.TemplateValue';
  export const TemplateValueDiscriminant = 'TEMPLATE';
  export const TemplateValueDiscriminantKey = 'valueType';
  export type TemplateValue = {
    value: string;
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.TemplateValue';
  } & { valueType?: 'TEMPLATE' };

  export const TimestampValueTypename =
    'com.hubspot.automation.extensions.v2.core.instance.values.TimestampValue';
  export const TimestampValueDiscriminant = 'TIMESTAMP';
  export const TimestampValueDiscriminantKey = 'valueType';
  export type TimestampValue = {
    __typename: 'com.hubspot.automation.extensions.v2.core.instance.values.TimestampValue';
  } & { valueType?: 'TIMESTAMP' };
}

export type DataSourceFilterOperator =
  | 'IS_KNOWN'
  | 'IS_NOT_KNOWN'
  | 'EQUALS'
  | 'NOT_EQUALS'
  | 'GREATER_THAN'
  | 'LESS_THAN'
  | 'GREATER_THAN_OR_EQUAL_TO'
  | 'LESS_THAN_OR_EQUAL_TO'
  | 'IN'
  | 'NOT_IN'
  | 'BETWEEN'
  | 'NOT_BETWEEN'
  | 'CONTAINS_ANY_OF'
  | 'DOES_NOT_CONTAIN_ANY_OF'
  | 'STARTS_WITH_ANY_OF'
  | 'ENDS_WITH_ANY_OF'
  | 'SET_CONTAINS_ANY_OF'
  | 'SET_DOES_NOT_CONTAIN_ANY_OF'
  | 'SET_IS_EXACTLY'
  | 'SET_IS_NOT_EXACTLY'
  | 'SET_CONTAINS_ALL_OF'
  | 'SET_DOES_NOT_CONTAIN_ALL_OF'
  | 'CONTAINS_TOKENS_ANY_OF'
  | 'DOES_NOT_CONTAIN_TOKENS_ANY_OF'
  | unhandledEnumCase;

export type DataSourceFilterType =
  | 'NUMBER'
  | 'STRING'
  | 'BOOLEAN'
  | 'JSON'
  | 'ANY'
  | 'DATE'
  | unhandledEnumCase;

export type OwnerAssignment = {
  type: Default<OwnerAssignmentType>;
  ownerId?: number;
  ownerProperty?: string;
};

export type SourceApp =
  | 'DEAL_PIPELINE_SETTINGS'
  | 'FEEDBACK'
  | 'ECOMM'
  | 'WORKFLOWS_APP'
  | 'AUTOMATION_PLATFORM_INTERNAL'
  | 'TICKET_PIPELINE_SETTINGS'
  | 'EMBEDDED_QUOTES'
  | 'WORKFLOWS_CLASSIC'
  | 'FEEDBACK_FOLLOW_UP'
  | 'TICKET_EMAIL_STATUS_SETTING'
  | 'SEQUENCES'
  | 'LEAD_FLOW'
  | 'FORM_FOLLOWUP_EMAIL'
  | 'ADS_FLOW'
  | 'DIRECT_API'
  | 'PUBLIC_API'
  | 'READ_ONLY'
  | 'FORECASTING'
  | 'FORM_FIELD_FOLLOWUP'
  | 'MARKETING_EMAIL_AUTOMATED'
  | 'SEQUENCES_CONTEXTUAL_AUTOMATION'
  | 'FORMS_APP'
  | 'LEAD_FLOWS_APP'
  | 'ADS_CONTEXTUAL_AUTOMATION'
  | 'CMS_FORM_MODULE_FIELD'
  | 'CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL'
  | 'CRM_MIGRATION'
  | 'SKILL_BASED_ROUTING'
  | 'ADVANCED_TICKET_SLAS'
  | 'PUBLIC_FLOW_API'
  | 'CALLING_IVR_APP'
  | 'JOURNEY_STAGE'
  | 'LEAD_PIPELINE_SETTINGS'
  | 'LEAD_AUTOMATION_RULES'
  | 'AUTOMATION_RULESETS_INTERNAL'
  | 'RULESETS_LEADS'
  | 'RULESETS_GLOBAL_DATA_PROTECTION'
  | 'RULESETS_TICKET_STATUS'
  | 'RULESETS_SKILL_BASED_ROUTING'
  | 'RULESETS_ADVANCED_TICKET_SLAS'
  | 'RULESETS_SEQUENCES'
  | 'RULESETS_PROSPECTING'
  | 'CUSTOM_OBJECT_PIPELINE_SETTINGS'
  | 'BUYER_INTENT_APP'
  | 'RULESETS_SECURITY_SETTINGS'
  | 'RULESETS_ACCOUNT_INSIGHTS'
  | 'CAMPAIGNS'
  | 'AGENT_STUDIO'
  | 'RULESETS_MARKETING_STUDIO'
  | 'PROJECT_PIPELINE_SETTINGS'
  | 'SERVICE_PIPELINE_SETTINGS'
  | 'RULESETS_HELPDESK_TICKET_REOPENING'
  | 'DATA_AGENT'
  | 'WORK_APP'
  | 'RULESETS_BREEZE_STUDIO'
  | 'RULESETS_QUOTE_APPROVALS'
  | 'RULESETS_BUYER_INTENT'
  | 'CUSTOMER_AGENT'
  | 'RULESETS_CONTACT_REENGAGEMENT'
  | 'WORKFLOWS_USER_TEST'
  | 'PIPELINE_SETTINGS'
  | 'AI_SCORING_EXCLUSION'
  | 'RULESETS_CUSTOMER_SUCCESS'
  | 'AUTOMATION_EXECUTION_INTERNAL_READONLY'
  | 'RULESETS_SOCIAL'
  | 'RULESETS_DATA_QUALITY'
  | unhandledEnumCase;

export type UpdateType = 'CREATE' | 'UPDATE' | 'DELETE' | unhandledEnumCase;

export type ExecutionState =
  | 'SUCCESS'
  | 'FAIL_RETRY'
  | 'FAIL_IRREPARABLE'
  | 'DEFERRED'
  | 'FAIL_CONTINUE'
  | 'FAIL_RESCHEDULE'
  | 'SKIPPED'
  | 'ASYNC'
  | 'PARTIAL_SUCCESS'
  | 'THROTTLED'
  | unhandledEnumCase;

export type OwnerAssignmentType =
  | 'OBJECT_OWNER'
  | 'CUSTOM'
  | 'OBJECT_PROPERTY'
  | 'NONE'
  | unhandledEnumCase;

export const AbTestBranchMetadataTypename =
  'com.hubspot.automationplatform.base.action.AbTestBranchMetadata';
export const AbTestBranchMetadataDiscriminant = 'AB_TEST_BRANCH';
export const AbTestBranchMetadataDiscriminantKey = 'actionType';
export type AbTestBranchMetadata = {
  inputValueFields: Default<InputValueField[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.AbTestBranchMetadata';
} & { actionType?: 'AB_TEST_BRANCH' };

export type Action = {
  portalId: number;
  flowId: number;
  instanceOutputFieldDefinitions: Default<
    ComHubspotAutomationDataPassingCoreModelOutput.OutputFieldDefinition[]
  >;
  flowVersion: Default<number>;
  actionId: number;
  metadata: ActionMetadata;
  connection?: Connection;
  rateLimit?: RateLimit;
  customProperties: Default<Record<string, string>>;
};

export const ActionMetadataDiscriminantKey = 'actionType';
export type ActionMetadata =
  | DelayActionMetadata
  | RecurActionMetadata
  | TaskActionMetadata
  | EmailActionMetadata
  | SetPropertyMetadata
  | StaticBranchMetadata
  | NoOpExecutionStateMetadata
  | ListBranchMetadata
  | EmailNotificationMetadata
  | InAppNotificationMetadata
  | RotateObjectMetadata
  | SlackNotificationMetadata
  | WebHookMetadata
  | AlterListMembershipMetadata
  | CreateObjectMetadata
  | EnrollInFlowMetadata
  | ClassicEnrollActionMetadata
  | ClassicAlterListMetadata
  | SendSmsNotificationMetadata
  | ClassicNotificationEmailMetadata
  | ClassicListBranchMetadata
  | ExtensionMetadata
  | UpdateEmailSubscriptionMetadata
  | CreateSalesforceCampaignMetadata
  | CreateSalesforceTaskMetadata
  | ClassicCopyCompanyPropertyMetadata
  | SequenceEmailSendMetadata
  | ClassicAnchoredDelayMetadata
  | WaitUntilMetadata
  | AdsAudienceMetadata
  | SetMarketingStatusMetadata
  | CustomCodeMetadata
  | FormulaMetadata
  | FetchObjectMetadata
  | DelayUntilDateMetadata
  | WhileLoopMetadata
  | AbTestBranchMetadata
  | ForEachLoopMetadata
  | CriteriaBranchMetadata;

export const AdsAudienceMetadataTypename =
  'com.hubspot.automationplatform.base.action.AdsAudienceMetadata';
export const AdsAudienceMetadataDiscriminant = 'ADS_AUDIENCE_MEMBERSHIP';
export const AdsAudienceMetadataDiscriminantKey = 'actionType';
export type AdsAudienceMetadata = {
  audienceId: number;
  shouldAdd: boolean;
  targetObjectsInputField?: InputValue;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.AdsAudienceMetadata';
} & { actionType?: 'ADS_AUDIENCE_MEMBERSHIP' };

export const AlterListMembershipMetadataTypename =
  'com.hubspot.automationplatform.base.action.AlterListMembershipMetadata';
export const AlterListMembershipMetadataDiscriminant = 'ALTER_LIST_MEMBERSHIP';
export const AlterListMembershipMetadataDiscriminantKey = 'actionType';
export type AlterListMembershipMetadata = {
  listId: number;
  shouldAdd: boolean;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.AlterListMembershipMetadata';
} & { actionType?: 'ALTER_LIST_MEMBERSHIP' };

export const ClassicAlterListMetadataTypename =
  'com.hubspot.automationplatform.base.action.ClassicAlterListMetadata';
export const ClassicAlterListMetadataDiscriminant =
  'CLASSIC_ALTER_LIST_MEMBERSHIP';
export const ClassicAlterListMetadataDiscriminantKey = 'actionType';
export type ClassicAlterListMetadata = {
  listId: number;
  shouldAdd: boolean;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.ClassicAlterListMetadata';
} & { actionType?: 'CLASSIC_ALTER_LIST_MEMBERSHIP' };

export const ClassicAnchoredDelayMetadataTypename =
  'com.hubspot.automationplatform.base.action.ClassicAnchoredDelayMetadata';
export const ClassicAnchoredDelayMetadataDiscriminant =
  'CLASSIC_ANCHORED_DELAY';
export const ClassicAnchoredDelayMetadataDiscriminantKey = 'actionType';
export type ClassicAnchoredDelayMetadata = {
  delay: TimeDelay;
  direction: AnchorDirection;
  inputValueFields: Default<InputValueField[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.ClassicAnchoredDelayMetadata';
} & { actionType?: 'CLASSIC_ANCHORED_DELAY' };

export const ClassicCopyCompanyPropertyMetadataTypename =
  'com.hubspot.automationplatform.base.action.ClassicCopyCompanyPropertyMetadata';
export const ClassicCopyCompanyPropertyMetadataDiscriminant =
  'CLASSIC_COPY_COMPANY_PROPERTY';
export const ClassicCopyCompanyPropertyMetadataDiscriminantKey = 'actionType';
export type ClassicCopyCompanyPropertyMetadata = {
  sourceProperty: Default<string>;
  targetProperty: Default<string>;
  targetObject: TargetObject;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.ClassicCopyCompanyPropertyMetadata';
} & { actionType?: 'CLASSIC_COPY_COMPANY_PROPERTY' };

export const ClassicEnrollActionMetadataTypename =
  'com.hubspot.automationplatform.base.action.ClassicEnrollActionMetadata';
export const ClassicEnrollActionMetadataDiscriminant =
  'CLASSIC_ENROLL_IN_WORKFLOW';
export const ClassicEnrollActionMetadataDiscriminantKey = 'actionType';
export type ClassicEnrollActionMetadata = {
  workflowId: number;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.ClassicEnrollActionMetadata';
} & { actionType?: 'CLASSIC_ENROLL_IN_WORKFLOW' };

export const ClassicListBranchMetadataTypename =
  'com.hubspot.automationplatform.base.action.ClassicListBranchMetadata';
export const ClassicListBranchMetadataDiscriminant = 'CLASSIC_LIST_BRANCH';
export const ClassicListBranchMetadataDiscriminantKey = 'actionType';
export type ClassicListBranchMetadata = {
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.ClassicListBranchMetadata';
} & { actionType?: 'CLASSIC_LIST_BRANCH' };

export const ClassicNotificationEmailMetadataTypename =
  'com.hubspot.automationplatform.base.action.ClassicNotificationEmailMetadata';
export const ClassicNotificationEmailMetadataDiscriminant =
  'CLASSIC_NOTIFICATION_EMAIL';
export const ClassicNotificationEmailMetadataDiscriminantKey = 'actionType';
export type ClassicNotificationEmailMetadata = {
  emailContentId: Default<number>;
  recipientEmails: Default<string[]>;
  recipientProperty?: string;
  targetContact?: InputValue;
  customProperties: Default<Record<string, InputValue>>;
  objectsForRendering: Default<
    Record<
      string,
      ComHubspotAutomationplatformFieldCoreInput.SingleObjectCoordinatesValue
    >
  >;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.ClassicNotificationEmailMetadata';
} & { actionType?: 'CLASSIC_NOTIFICATION_EMAIL' };

export const CreateObjectMetadataTypename =
  'com.hubspot.automationplatform.base.action.CreateObjectMetadata';
export const CreateObjectMetadataDiscriminant = 'CREATE_OBJECT';
export const CreateObjectMetadataDiscriminantKey = 'actionType';
export type CreateObjectMetadata = {
  objectTypeId: string;
  properties: Default<PropertyUpdate[]>;
  associations: Default<AssociationUpdate[]>;
  targetObjectsInputField?: InputValue;
  lineItemFromProductCreateRequests: Default<
    LineItemFromProductCreateRequest[]
  >;
  primaryAssociationTarget?: ComHubspotAutomationplatformFieldCoreInput.SingleObjectCoordinatesValue;
  primaryAssociationSpec?: AssociationSpec;
  useExplicitAssociations: Default<boolean>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.CreateObjectMetadata';
} & { actionType?: 'CREATE_OBJECT' };

export const CreateSalesforceCampaignMetadataTypename =
  'com.hubspot.automationplatform.base.action.CreateSalesforceCampaignMetadata';
export const CreateSalesforceCampaignMetadataDiscriminant =
  'CREATE_SALESFORCE_CAMPAIGN';
export const CreateSalesforceCampaignMetadataDiscriminantKey = 'actionType';
export type CreateSalesforceCampaignMetadata = {
  campaignId: Default<string>;
  status: Default<string>;
  targetObjectsInputField?: InputValue;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.CreateSalesforceCampaignMetadata';
} & { actionType?: 'CREATE_SALESFORCE_CAMPAIGN' };

export const CreateSalesforceTaskMetadataTypename =
  'com.hubspot.automationplatform.base.action.CreateSalesforceTaskMetadata';
export const CreateSalesforceTaskMetadataDiscriminant =
  'CREATE_SALESFORCE_TASK';
export const CreateSalesforceTaskMetadataDiscriminantKey = 'actionType';
export type CreateSalesforceTaskMetadata = {
  status: Default<string>;
  email: Default<string>;
  subject: Default<string>;
  comments: Default<string>;
  priority: Default<string>;
  daysFrom: number;
  targetObjectsInputField?: InputValue;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.CreateSalesforceTaskMetadata';
} & { actionType?: 'CREATE_SALESFORCE_TASK' };

export const CriteriaBranchMetadataTypename =
  'com.hubspot.automationplatform.base.action.CriteriaBranchMetadata';
export const CriteriaBranchMetadataDiscriminant = 'CRITERIA_BRANCH';
export const CriteriaBranchMetadataDiscriminantKey = 'actionType';
export type CriteriaBranchMetadata = {
  inputsFromConnections: Default<InputValueField[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.CriteriaBranchMetadata';
} & { actionType?: 'CRITERIA_BRANCH' };

export const CustomCodeMetadataTypename =
  'com.hubspot.automationplatform.base.action.CustomCodeMetadata';
export const CustomCodeMetadataDiscriminant = 'CUSTOM_CODE';
export const CustomCodeMetadataDiscriminantKey = 'actionType';
export type CustomCodeMetadata = {
  /** @deprecated */
  functionId?: number;
  actionTypeId: Default<string>;
  functionSource?: string;
  secrets: Default<string[]>;
  runtime?: ActionFunctionRuntime;
  instanceId?: number;
  instanceRevisionId?: number;
  inputFields: Default<InputVariable[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.CustomCodeMetadata';
} & { actionType?: 'CUSTOM_CODE' };

export const DelayActionMetadataTypename =
  'com.hubspot.automationplatform.base.action.DelayActionMetadata';
export const DelayActionMetadataDiscriminant = 'DELAY';
export const DelayActionMetadataDiscriminantKey = 'actionType';
export type DelayActionMetadata = {
  delay: TimeDelay;
  inputValueFields: Default<InputValueField[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.DelayActionMetadata';
} & { actionType?: 'DELAY' };

export const DelayUntilDateMetadataTypename =
  'com.hubspot.automationplatform.base.action.DelayUntilDateMetadata';
export const DelayUntilDateMetadataDiscriminant = 'DELAY_UNTIL_DATE';
export const DelayUntilDateMetadataDiscriminantKey = 'actionType';
export type DelayUntilDateMetadata = {
  date: InputValue;
  timeOfDay?: TimeOfDay;
  timeZoneStrategy?: TimeDelayTimeZoneStrategy;
  targetObjectsInputField?: InputValue;
  propertyType?: ComHubspotContactsDataContactsProtos.Type;
  delta: Default<TimeDelta>;
  inputValueFields: Default<InputValueField[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.DelayUntilDateMetadata';
} & { actionType?: 'DELAY_UNTIL_DATE' };

export const EmailActionMetadataTypename =
  'com.hubspot.automationplatform.base.action.EmailActionMetadata';
export const EmailActionMetadataDiscriminant = 'EMAIL';
export const EmailActionMetadataDiscriminantKey = 'actionType';
export type EmailActionMetadata = {
  contentId: Default<number>;
  appId?: number;
  recipients: Default<AssociationRecipientSpec[]>;
  recipientInputs: Default<
    ComHubspotAutomationplatformFieldCoreInput.SingleObjectCoordinatesValue[]
  >;
  utmSource: Default<string>;
  customProperties: Default<Record<string, InputValue>>;
  objectsForRendering: Default<
    Record<
      string,
      ComHubspotAutomationplatformFieldCoreInput.SingleObjectCoordinatesValue
    >
  >;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.EmailActionMetadata';
} & { actionType?: 'EMAIL' };

export const EmailNotificationMetadataTypename =
  'com.hubspot.automationplatform.base.action.EmailNotificationMetadata';
export const EmailNotificationMetadataDiscriminant = 'EMAIL_NOTIFICATION';
export const EmailNotificationMetadataDiscriminantKey = 'actionType';
export type EmailNotificationMetadata = {
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  subject: Default<string>;
  body: Default<string>;
  ownerProperties: Default<string[]>;
  teamIds: Default<number[]>;
  excludeNonDefaultTeamMembers: Default<boolean>;
  userIds: Default<number[]>;
  userIdsAndOwnerProperties: Default<InputValue[]>;
  __typename: 'com.hubspot.automationplatform.base.action.EmailNotificationMetadata';
} & { actionType?: 'EMAIL_NOTIFICATION' };

export const EnrollInFlowMetadataTypename =
  'com.hubspot.automationplatform.base.action.EnrollInFlowMetadata';
export const EnrollInFlowMetadataDiscriminant = 'ENROLL_IN_FLOW';
export const EnrollInFlowMetadataDiscriminantKey = 'actionType';
export type EnrollInFlowMetadata = {
  objectToEnrollOverride?: InputValue;
  flowId: number;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.EnrollInFlowMetadata';
} & { actionType?: 'ENROLL_IN_FLOW' };

export const ExtensionMetadataTypename =
  'com.hubspot.automationplatform.base.action.ExtensionMetadata';
export const ExtensionMetadataDiscriminant = 'AUTOMATION_EXTENSION';
export const ExtensionMetadataDiscriminantKey = 'actionType';
export type ExtensionMetadata = {
  /** @deprecated */
  extensionInstanceId?: number;
  /** @deprecated */
  extensionInstanceVersion?: number;
  /** @deprecated */
  extensionInstance?: ExtensionInstanceFields;
  actionTypeId: Default<string>;
  inputValueFields: Default<InputValueField[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.ExtensionMetadata';
} & { actionType?: 'AUTOMATION_EXTENSION' };

export const FetchObjectMetadataTypename =
  'com.hubspot.automationplatform.base.action.FetchObjectMetadata';
export const FetchObjectMetadataDiscriminant = 'FETCH_OBJECT';
export const FetchObjectMetadataDiscriminantKey = 'actionType';
export type FetchObjectMetadata = {
  fetchedObjectTypeId: string;
  associationSpecsFromFetchedObjectType: Default<AssociationSpec[]>;
  associatedObjectId?: InputValue;
  filterGroups: Default<CrmSearchFilterWithInputValue[][]>;
  sorts: Default<Sort[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.FetchObjectMetadata';
} & { actionType?: 'FETCH_OBJECT' };

export const ForEachLoopMetadataTypename =
  'com.hubspot.automationplatform.base.action.ForEachLoopMetadata';
export const ForEachLoopMetadataDiscriminant = 'FOR_EACH_LOOP';
export const ForEachLoopMetadataDiscriminantKey = 'actionType';
export type ForEachLoopMetadata = {
  targetObjectsInputField?: ListInputValue;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.ForEachLoopMetadata';
} & { actionType?: 'FOR_EACH_LOOP' };

export const FormulaMetadataTypename =
  'com.hubspot.automationplatform.base.action.FormulaMetadata';
export const FormulaMetadataDiscriminant = 'FORMULA';
export const FormulaMetadataDiscriminantKey = 'actionType';
export type FormulaMetadata = {
  variableContext: Default<InputVariable[]>;
  template: Default<string>;
  languageTag?: string;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.FormulaMetadata';
} & { actionType?: 'FORMULA' };

export const InAppNotificationMetadataTypename =
  'com.hubspot.automationplatform.base.action.InAppNotificationMetadata';
export const InAppNotificationMetadataDiscriminant = 'IN_APP_NOTIFICATION';
export const InAppNotificationMetadataDiscriminantKey = 'actionType';
export type InAppNotificationMetadata = {
  deliveryMethod: NotificationDeliveryMethod;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  subject: Default<string>;
  body: Default<string>;
  ownerProperties: Default<string[]>;
  teamIds: Default<number[]>;
  excludeNonDefaultTeamMembers: Default<boolean>;
  userIds: Default<number[]>;
  userIdsAndOwnerProperties: Default<InputValue[]>;
  __typename: 'com.hubspot.automationplatform.base.action.InAppNotificationMetadata';
} & { actionType?: 'IN_APP_NOTIFICATION' };

export const ListBranchMetadataTypename =
  'com.hubspot.automationplatform.base.action.ListBranchMetadata';
export const ListBranchMetadataDiscriminant = 'LIST_BRANCH';
export const ListBranchMetadataDiscriminantKey = 'actionType';
export type ListBranchMetadata = {
  inputValueFields: Default<InputValueField[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.ListBranchMetadata';
} & { actionType?: 'LIST_BRANCH' };

export const NoOpExecutionStateMetadataTypename =
  'com.hubspot.automationplatform.base.action.NoOpExecutionStateMetadata';
export const NoOpExecutionStateMetadataDiscriminant = 'NOOP_EXECUTION_STATE';
export const NoOpExecutionStateMetadataDiscriminantKey = 'actionType';
export type NoOpExecutionStateMetadata = {
  executionState: ExecutionState;
  validationResultOverride?: ValidationResultOverrideSettings;
  numAttempts?: number;
  inputValueFields: Default<InputValueField[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.NoOpExecutionStateMetadata';
} & { actionType?: 'NOOP_EXECUTION_STATE' };

export const RecurActionMetadataTypename =
  'com.hubspot.automationplatform.base.action.RecurActionMetadata';
export const RecurActionMetadataDiscriminant = 'RECUR';
export const RecurActionMetadataDiscriminantKey = 'actionType';
export type RecurActionMetadata = {
  anchorTimestamp?: number;
  delay: TimeDelay;
  inputValueFields: Default<InputValueField[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.RecurActionMetadata';
} & { actionType?: 'RECUR' };

export const RotateObjectMetadataTypename =
  'com.hubspot.automationplatform.base.action.RotateObjectMetadata';
export const RotateObjectMetadataDiscriminant = 'ROTATE_OBJECT';
export const RotateObjectMetadataDiscriminantKey = 'actionType';
export type RotateObjectMetadata = {
  targetProperty: Default<string>;
  overwriteCurrentOwner: Default<boolean>;
  routingRuleDefinition?: RoutingRuleDefinition;
  targetInboxId?: number;
  targetObjectsInputField?: InputValue;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  teamIds: Default<number[]>;
  excludeNonDefaultTeamMembers: Default<boolean>;
  userIds: Default<number[]>;
  userIdsAndOwnerProperties: Default<InputValue[]>;
  __typename: 'com.hubspot.automationplatform.base.action.RotateObjectMetadata';
} & { actionType?: 'ROTATE_OBJECT' };

export const SendSmsNotificationMetadataTypename =
  'com.hubspot.automationplatform.base.action.SendSmsNotificationMetadata';
export const SendSmsNotificationMetadataDiscriminant = 'SEND_SMS_NOTIFICATION';
export const SendSmsNotificationMetadataDiscriminantKey = 'actionType';
export type SendSmsNotificationMetadata = {
  body: Default<string>;
  staticTo?: string;
  toProperty?: string;
  userId?: number;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.SendSmsNotificationMetadata';
} & { actionType?: 'SEND_SMS_NOTIFICATION' };

export const SequenceEmailSendMetadataTypename =
  'com.hubspot.automationplatform.base.action.SequenceEmailSendMetadata';
export const SequenceEmailSendMetadataDiscriminant = 'SEQUENCE_EMAIL_SEND';
export const SequenceEmailSendMetadataDiscriminantKey = 'actionType';
export type SequenceEmailSendMetadata = {
  sequenceStepOrder: number;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.SequenceEmailSendMetadata';
} & { actionType?: 'SEQUENCE_EMAIL_SEND' };

export const SetMarketingStatusMetadataTypename =
  'com.hubspot.automationplatform.base.action.SetMarketingStatusMetadata';
export const SetMarketingStatusMetadataDiscriminant = 'SET_MARKETING_STATUS';
export const SetMarketingStatusMetadataDiscriminantKey = 'actionType';
export type SetMarketingStatusMetadata = {
  marketableType: Default<MarketableType>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.SetMarketingStatusMetadata';
} & { actionType?: 'SET_MARKETING_STATUS' };

export const SetPropertyMetadataTypename =
  'com.hubspot.automationplatform.base.action.SetPropertyMetadata';
export const SetPropertyMetadataDiscriminant = 'SET_PROPERTY';
export const SetPropertyMetadataDiscriminantKey = 'actionType';
export type SetPropertyMetadata = {
  targetProperty: PropertySpec;
  value: InputValue;
  operation?: Operation;
  targetObjectsInputField?: InputValue;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.SetPropertyMetadata';
} & { actionType?: 'SET_PROPERTY' };

export const SlackNotificationMetadataTypename =
  'com.hubspot.automationplatform.base.action.SlackNotificationMetadata';
export const SlackNotificationMetadataDiscriminant = 'SLACK_NOTIFICATION';
export const SlackNotificationMetadataDiscriminantKey = 'actionType';
export type SlackNotificationMetadata = {
  text: Default<string>;
  /** @deprecated */
  channelIds: Default<string[]>;
  slackChannelIds: Default<string[]>;
  slackUserIds: Default<string[]>;
  recipientOwnerProperties: Default<string[]>;
  objectProperties: Default<string[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.SlackNotificationMetadata';
} & { actionType?: 'SLACK_NOTIFICATION' };

export const StaticBranchMetadataTypename =
  'com.hubspot.automationplatform.base.action.StaticBranchMetadata';
export const StaticBranchMetadataDiscriminant = 'STATIC_BRANCH';
export const StaticBranchMetadataDiscriminantKey = 'actionType';
export type StaticBranchMetadata = {
  inputValue: InputValue;
  inputValueFields: Default<InputValueField[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.StaticBranchMetadata';
} & { actionType?: 'STATIC_BRANCH' };

export type SubtaskMetadata = {
  taskType: Default<TaskType>;
  customTaskType?: string;
  subject: Default<string>;
  body?: string;
  associations: Default<AssociationUpdate[]>;
  useExplicitAssociations: Default<boolean>;
  ownerAssignment: Default<OwnerAssignment>;
  reminderTime?: TimeDelay;
  dueTime?: TimeDelay;
  startDate?: TimeDelay;
  priority?: Priority;
  queueId?: number;
  targetObjectsInputField?: InputValue;
  ownerInputField?: InputValue;
  customProperties: Default<PropertyUpdate[]>;
  emailTemplateId?: number;
};

export const TaskActionMetadataTypename =
  'com.hubspot.automationplatform.base.action.TaskActionMetadata';
export const TaskActionMetadataDiscriminant = 'TASK';
export const TaskActionMetadataDiscriminantKey = 'actionType';
export type TaskActionMetadata = {
  subtasks: Default<SubtaskMetadata[]>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  taskType: Default<TaskType>;
  customTaskType?: string;
  subject: Default<string>;
  body?: string;
  associations: Default<AssociationUpdate[]>;
  useExplicitAssociations: Default<boolean>;
  ownerAssignment: Default<OwnerAssignment>;
  reminderTime?: TimeDelay;
  dueTime?: TimeDelay;
  startDate?: TimeDelay;
  priority?: Priority;
  queueId?: number;
  targetObjectsInputField?: InputValue;
  ownerInputField?: InputValue;
  customProperties: Default<PropertyUpdate[]>;
  emailTemplateId?: number;
  __typename: 'com.hubspot.automationplatform.base.action.TaskActionMetadata';
} & { actionType?: 'TASK' };

export const UpdateEmailSubscriptionMetadataTypename =
  'com.hubspot.automationplatform.base.action.UpdateEmailSubscriptionMetadata';
export const UpdateEmailSubscriptionMetadataDiscriminant =
  'UPDATE_EMAIL_SUBSCRIPTION';
export const UpdateEmailSubscriptionMetadataDiscriminantKey = 'actionType';
export type UpdateEmailSubscriptionMetadata = {
  subscriptionId: number;
  optState: Default<ComHubspotEmailEmailProtos.OptState>;
  legalBasis?: SubscriptionLegalBasisType;
  legalBasisExplanation?: string;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.UpdateEmailSubscriptionMetadata';
} & { actionType?: 'UPDATE_EMAIL_SUBSCRIPTION' };

export const WaitUntilMetadataTypename =
  'com.hubspot.automationplatform.base.action.WaitUntilMetadata';
export const WaitUntilMetadataDiscriminant = 'WAIT_UNTIL';
export const WaitUntilMetadataDiscriminantKey = 'actionType';
export type WaitUntilMetadata = {
  targetObjectOverride?: InputValue;
  eventFilters: Default<EventFilterUpdate[]>;
  expiration: Default<TimeDelay>;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.WaitUntilMetadata';
} & { actionType?: 'WAIT_UNTIL' };

export const WebHookMetadataTypename =
  'com.hubspot.automationplatform.base.action.WebHookMetadata';
export const WebHookMetadataDiscriminant = 'WEBHOOK';
export const WebHookMetadataDiscriminantKey = 'actionType';
export type WebHookMetadata = {
  method: Default<StandardHttpMethod>;
  url: Default<string>;
  appId?: number;
  actionTypeId?: string;
  outputFields?: ComHubspotAutomationplatformFieldCoreDefinition.OutputFieldDefinition[];
  queryParams?: WebhookQueryParams;
  jsonSchema?: JsonSchema;
  authSettings?: WebhookAuthSettings;
  targetObjectsInputField?: InputValue;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.WebHookMetadata';
} & { actionType?: 'WEBHOOK' };

export const WhileLoopMetadataTypename =
  'com.hubspot.automationplatform.base.action.WhileLoopMetadata';
export const WhileLoopMetadataDiscriminant = 'WHILE_LOOP';
export const WhileLoopMetadataDiscriminantKey = 'actionType';
export type WhileLoopMetadata = {
  delay: TimeUnitDelay;
  objectRequestOptions: Default<ComHubspotAutomationActionsCoreInstance.InstanceObjectRequestOptions>;
  usingUnifiedFieldsAsSourceOfTruth?: boolean;
  __typename: 'com.hubspot.automationplatform.base.action.WhileLoopMetadata';
} & { actionType?: 'WHILE_LOOP' };

export type TargetObject = 'COMPANY' | 'CONTACT' | unhandledEnumCase;

export type MarketableType =
  | 'MARKETABLE'
  | 'MARKETABLE_UNTIL_RENEWAL'
  | unhandledEnumCase;

export type Operation = 'APPEND' | 'REPLACE' | 'REMOVE' | unhandledEnumCase;

export type AnchorDirection = 'BEFORE' | 'AFTER' | unhandledEnumCase;

export type AssociationOptions = {
  backfillDuration: AssociationTimelineBackfillDuration;
};

export type AssociationTimelineBackfillDuration = {
  type: ComHubspotAutomationplatformBaseActionAssociationsAssociationTimelineBackfillDurationIF.Type;
  daysAgo?: number;
  timestamp?: number;
};

export type AssociationUpdate = {
  targetSpec: AssociationSpec;
  value: SetAssociationValue;
  associationOptions?: AssociationOptions;
};

export const CopyAssociationValueTypename =
  'com.hubspot.automationplatform.base.action.associations.CopyAssociationValue';
export const CopyAssociationValueDiscriminant = 'COPY_ASSOCIATION';
export const CopyAssociationValueDiscriminantKey = 'type';
export type CopyAssociationValue = {
  sourceSpec: AssociationSpec;
  __typename: 'com.hubspot.automationplatform.base.action.associations.CopyAssociationValue';
} & { type?: 'COPY_ASSOCIATION' };

export const EnrolledObjectValueTypename =
  'com.hubspot.automationplatform.base.action.associations.EnrolledObjectValue';
export const EnrolledObjectValueDiscriminant = 'ENROLLED_OBJECT';
export const EnrolledObjectValueDiscriminantKey = 'type';
export type EnrolledObjectValue = {
  __typename: 'com.hubspot.automationplatform.base.action.associations.EnrolledObjectValue';
} & { type?: 'ENROLLED_OBJECT' };

export const SetAssociationValueDiscriminantKey = 'type';
export type SetAssociationValue = CopyAssociationValue | EnrolledObjectValue;

export namespace ComHubspotAutomationplatformBaseActionAssociationsAssociationTimelineBackfillDurationIF {
  export type Type =
    | 'LAST_N_DAYS'
    | 'CUSTOM_DATE'
    | 'ALL_TIME'
    | unhandledEnumCase;
}

export type CrmSearchFilterWithInputValue = {
  inputValue?: InputValue;
  highInputValue?: InputValue;
  inputValues: Default<InputValue[]>;
  property: string;
  operator: FilterOperator;
  comparisonProperty?: string;
  dateTimeFormat?: FilterDateTimeFormat;
  timeUnit?: FilterTimeUnit;
  timeUnitCount?: number;
  inclusive?: boolean;
  upperBoundInclusive?: boolean;
  lowerBoundInclusive?: boolean;
  propertySuffix?: string;
  rollingOffsetUnit?: FilterTimeUnit;
  direction?: Direction;
  rollForward: Default<boolean>;
  rollingOffset: Default<number>;
};

export type TimeDelta = {
  delta: Default<number>;
  timeUnit: Default<ChronoUnit>;
};

export type AssociationRecipientSpec = { associationSpec: AssociationSpec };

export type EventFilter = {
  eventTypeId: ObjectTypeIdProto;
  filter?: FilterBranch;
  objectTypeId?: string;
};

export type EventFilterId = { id: number; version: number };

export type EventFilterUpdate = {
  updateType?: UpdateType;
  eventFilterId?: EventFilterId;
  eventFilter?: EventFilter;
  listId?: number;
};

export const AssociationPropertySpecTypename =
  'com.hubspot.automationplatform.base.action.properties.AssociationPropertySpec';
export const AssociationPropertySpecDiscriminant = 'ASSOCIATION';
export const AssociationPropertySpecDiscriminantKey = 'source';
export type AssociationPropertySpec = {
  associationSpec: AssociationSpec;
  propertyName: Default<string>;
  __typename: 'com.hubspot.automationplatform.base.action.properties.AssociationPropertySpec';
} & { source?: 'ASSOCIATION' };

export const CoordinatesInputPropertySpecTypename =
  'com.hubspot.automationplatform.base.action.properties.CoordinatesInputPropertySpec';
export const CoordinatesInputPropertySpecDiscriminant =
  'OBJECT_COORDINATES_INPUT';
export const CoordinatesInputPropertySpecDiscriminantKey = 'source';
export type CoordinatesInputPropertySpec = {
  propertyName: Default<string>;
  __typename: 'com.hubspot.automationplatform.base.action.properties.CoordinatesInputPropertySpec';
} & { source?: 'OBJECT_COORDINATES_INPUT' };

export const ObjectPropertySpecTypename =
  'com.hubspot.automationplatform.base.action.properties.ObjectPropertySpec';
export const ObjectPropertySpecDiscriminant = 'OBJECT';
export const ObjectPropertySpecDiscriminantKey = 'source';
export type ObjectPropertySpec = {
  propertyName: Default<string>;
  __typename: 'com.hubspot.automationplatform.base.action.properties.ObjectPropertySpec';
} & { source?: 'OBJECT' };

export const PropertySpecDiscriminantKey = 'source';
export type PropertySpec =
  | ObjectPropertySpec
  | AssociationPropertySpec
  | CoordinatesInputPropertySpec;

export type PropertyUpdate = {
  targetProperty: string;
  value: InputValue;
  operation: Default<Operation>;
};

export const AbTestBranchConnectionTypename =
  'com.hubspot.automationplatform.base.connection.AbTestBranchConnection';
export const AbTestBranchConnectionDiscriminant = 'AB_TEST_BRANCH';
export const AbTestBranchConnectionDiscriminantKey = 'connectionType';
export type AbTestBranchConnection = {
  connections: Default<AbTestConnection[]>;
  __typename: 'com.hubspot.automationplatform.base.connection.AbTestBranchConnection';
} & { connectionType?: 'AB_TEST_BRANCH' };

export type AbTestConnection = {
  connection?: SingleConnection;
  branchName?: string;
  percentage?: number;
};

export type ClassicListAndConnection = {
  listId?: number;
  connection?: Connection;
  branchName?: string;
};

export const ClassicListBranchConnectionTypename =
  'com.hubspot.automationplatform.base.connection.ClassicListBranchConnection';
export const ClassicListBranchConnectionDiscriminant = 'CLASSIC_LIST_BRANCH';
export const ClassicListBranchConnectionDiscriminantKey = 'connectionType';
export type ClassicListBranchConnection = {
  listBranches: Default<ClassicListAndConnection[]>;
  defaultConnection?: Connection;
  defaultBranchName?: string;
  /** @deprecated */
  classicListId?: number;
  /** @deprecated */
  acceptActionId?: number;
  /** @deprecated */
  rejectActionId?: number;
  __typename: 'com.hubspot.automationplatform.base.connection.ClassicListBranchConnection';
} & { connectionType?: 'CLASSIC_LIST_BRANCH' };

export const ConnectionDiscriminantKey = 'connectionType';
export type Connection =
  | SingleConnection
  | StaticBranchConnection
  | ListBranchConnection
  | ClassicListBranchConnection
  | WhileLoopConnection
  | AbTestBranchConnection
  | ForEachLoopConnection
  | InlineBranchConnection
  | CriteriaBranchConnection;

export const CriteriaBranchConnectionTypename =
  'com.hubspot.automationplatform.base.connection.CriteriaBranchConnection';
export const CriteriaBranchConnectionDiscriminant = 'CRITERIA_BRANCH';
export const CriteriaBranchConnectionDiscriminantKey = 'connectionType';
export type CriteriaBranchConnection = {
  branches: Default<CriteriaConnection[]>;
  defaultConnection?: SingleConnection;
  defaultBranchName?: string;
  __typename: 'com.hubspot.automationplatform.base.connection.CriteriaBranchConnection';
} & { connectionType?: 'CRITERIA_BRANCH' };

export type CriteriaBranchCriterion = {
  input: InputValueWithId;
  comparison: InputValueWithId;
  type: DataSourceFilterType;
  operator: DataSourceFilterOperator;
  includeRecordsWithNoValue: Default<boolean>;
};

export type CriteriaBranchGroup = {
  criteria: Default<CriteriaBranchCriterion[]>;
  ilsCriteria: Default<IlsCriterion[]>;
};

export type CriteriaConnection = {
  criteriaGroups: Default<CriteriaBranchGroup[]>;
  connection?: SingleConnection;
  branchName?: string;
};

export type EdgeType = 'STANDARD' | 'GOTO' | unhandledEnumCase;

export type FailureBehavior = 'CONTINUE' | 'TERMINATE' | unhandledEnumCase;

export const ForEachLoopConnectionTypename =
  'com.hubspot.automationplatform.base.connection.ForEachLoopConnection';
export const ForEachLoopConnectionDiscriminant = 'FOR_EACH_LOOP';
export const ForEachLoopConnectionDiscriminantKey = 'connectionType';
export type ForEachLoopConnection = {
  inLoopConnection?: SingleConnection;
  exitLoopConnection?: SingleConnection;
  __typename: 'com.hubspot.automationplatform.base.connection.ForEachLoopConnection';
} & { connectionType?: 'FOR_EACH_LOOP' };

export type IlsCriterion = {
  targetObject: InputValueWithId;
  filterBranch: FilterBranch;
  listId?: number;
};

export const InlineBranchConnectionTypename =
  'com.hubspot.automationplatform.base.connection.InlineBranchConnection';
export const InlineBranchConnectionDiscriminant = 'INLINE_BRANCH';
export const InlineBranchConnectionDiscriminantKey = 'connectionType';
export type InlineBranchConnection = {
  fieldKey: string;
  connections: Default<StaticConnection[]>;
  defaultConnection?: SingleConnection;
  defaultBranchName?: string;
  __typename: 'com.hubspot.automationplatform.base.connection.InlineBranchConnection';
} & { connectionType?: 'INLINE_BRANCH' };

export type InputValueWithId = { inputId: Default<string>; value: InputValue };

export type ListAndConnection = {
  listId?: number;
  filterBranch?: FilterBranch;
  connection?: Connection;
  branchName?: string;
};

export const ListBranchConnectionTypename =
  'com.hubspot.automationplatform.base.connection.ListBranchConnection';
export const ListBranchConnectionDiscriminant = 'LIST_BRANCH';
export const ListBranchConnectionDiscriminantKey = 'connectionType';
export type ListBranchConnection = {
  listBranches: Default<ListAndConnection[]>;
  defaultConnection?: Connection;
  defaultBranchName?: string;
  __typename: 'com.hubspot.automationplatform.base.connection.ListBranchConnection';
} & { connectionType?: 'LIST_BRANCH' };

export const SingleConnectionTypename =
  'com.hubspot.automationplatform.base.connection.SingleConnection';
export const SingleConnectionDiscriminant = 'SINGLE';
export const SingleConnectionDiscriminantKey = 'connectionType';
export type SingleConnection = {
  nextActionId: number;
  edgeType: Default<EdgeType>;
  failureBehavior?: FailureBehavior;
  __typename: 'com.hubspot.automationplatform.base.connection.SingleConnection';
} & { connectionType?: 'SINGLE' };

export const StaticBranchConnectionTypename =
  'com.hubspot.automationplatform.base.connection.StaticBranchConnection';
export const StaticBranchConnectionDiscriminant = 'STATIC_BRANCH';
export const StaticBranchConnectionDiscriminantKey = 'connectionType';
export type StaticBranchConnection = {
  connections: Default<StaticConnection[]>;
  defaultConnection?: SingleConnection;
  defaultBranchName?: string;
  __typename: 'com.hubspot.automationplatform.base.connection.StaticBranchConnection';
} & { connectionType?: 'STATIC_BRANCH' };

export type StaticBranchOperator =
  | 'IS_EQUAL_TO'
  | 'IS_NOT_EQUAL_TO'
  | 'IS_GREATER_THAN'
  | 'IS_GREATER_THAN_OR_EQUAL_TO'
  | 'IS_LESS_THAN'
  | 'IS_LESS_THAN_OR_EQUAL_TO'
  | 'CONTAINS'
  | 'DOES_NOT_CONTAIN'
  | 'STARTS_WITH'
  | 'ENDS_WITH'
  | 'IS_KNOWN'
  | 'IS_UNKNOWN'
  | unhandledEnumCase;

export type StaticConnection = {
  value: Default<string>;
  connection?: SingleConnection;
  operator: Default<StaticBranchOperator>;
};

export const WhileLoopConnectionTypename =
  'com.hubspot.automationplatform.base.connection.WhileLoopConnection';
export const WhileLoopConnectionDiscriminant = 'WHILE_LOOP';
export const WhileLoopConnectionDiscriminantKey = 'connectionType';
export type WhileLoopConnection = {
  loopBranch: WhileLoopListAndConnection;
  defaultConnection?: SingleConnection;
  defaultBranchName?: string;
  __typename: 'com.hubspot.automationplatform.base.connection.WhileLoopConnection';
} & { connectionType?: 'WHILE_LOOP' };

export type WhileLoopListAndConnection = {
  listId?: number;
  filterBranch?: FilterBranch;
  connection?: SingleConnection;
  branchName?: string;
};

export type ValidationResultOverrideSettings = {
  validationResultType: ValidationResultType;
  expirationTimestamp: number;
  throttleDelay?: string;
};

export type ValidationResultType =
  | 'ACTION_ERROR'
  | 'INVALID_ENROLLMENT_STATE'
  | 'INVALID_ENROLLMENT_STATE_UNENROLL'
  | 'CANCELLED_ENROLLMENT_STATE'
  | 'PARTIALLY_COMPLETED_ACTION'
  | 'ACTION_ALREADY_EXECUTED'
  | 'SUCCESS'
  | 'REROUTE'
  | 'ACTION_SKIP'
  | 'DEFER'
  | 'RATE_LIMIT'
  | 'USAGE_CREDITS_EXHAUSTED'
  | 'AGENT_RUN_LIMIT_EXCEEDED'
  | 'THROTTLE'
  | unhandledEnumCase;

export const ActionDataIdentifierTypename =
  'com.hubspot.automationplatform.field.core.ActionDataIdentifier';
export const ActionDataIdentifierDiscriminant = 'ACTION';
export const ActionDataIdentifierDiscriminantKey = 'type';
export type ActionDataIdentifier = {
  actionId: number;
  dataKey: string;
  __typename: 'com.hubspot.automationplatform.field.core.ActionDataIdentifier';
} & { type?: 'ACTION' };

export type DataSourceType =
  | 'ENROLLMENT_EVENTS'
  | 'ENROLLMENT_DATASET'
  | 'ENROLLED_OBJECT'
  | 'FETCHED_OBJECTS'
  | 'ACTION_OUTPUTS'
  | 'TRIGGER'
  | 'UNKNOWN'
  | unhandledEnumCase;

export type DelayCountingStrategy = 'BUSINESS_DAYS' | unhandledEnumCase;

export const EnrollmentDataIdentifierTypename =
  'com.hubspot.automationplatform.field.core.EnrollmentDataIdentifier';
export const EnrollmentDataIdentifierDiscriminant = 'ENROLLMENT';
export const EnrollmentDataIdentifierDiscriminantKey = 'type';
export type EnrollmentDataIdentifier = {
  propertyName: string;
  __typename: 'com.hubspot.automationplatform.field.core.EnrollmentDataIdentifier';
} & { type?: 'ENROLLMENT' };

export const FieldDataIdentifierDiscriminantKey = 'type';
export type FieldDataIdentifier =
  | ActionDataIdentifier
  | EnrollmentDataIdentifier;

export type RateLimit = { limitPerTimeWindow: number; timeWindow: string };

export type TimeDelay = {
  delta: number;
  timeUnit: Default<ChronoUnit>;
  timeOfDay?: TimeOfDay;
  daysOfWeek: Default<DayOfWeek[]>;
  optionalTimeZoneStrategy?: TimeDelayTimeZoneStrategy;
  delayCountingStrategy?: DelayCountingStrategy;
  weekendStartStrategy?: WeekendStartStrategy;
};

export type TimeDelayTimeZoneStrategy = {
  type: ComHubspotAutomationplatformFieldCoreTimeDelayTimeZoneStrategyIF.Type;
  staticTimeZoneId?: string;
};

export type TimeOfDay = { hour: number; minute: number };

export type TimeUnitDelay = { delta: number; timeUnit: Default<ChronoUnit> };

export type WeekendStartStrategy =
  | 'IMMEDIATELY'
  | 'NEXT_BUSINESS_DAY'
  | unhandledEnumCase;

export namespace ComHubspotAutomationplatformFieldCoreTimeDelayTimeZoneStrategyIF {
  export type Type =
    | 'PORTAL'
    | 'ENROLLED_OBJECT'
    | 'STATIC_TIME_ZONE'
    | unhandledEnumCase;
}

export namespace ComHubspotAutomationplatformFieldCoreDefinition {
  export type FieldTypeDefinition = {
    name: string;
    type: ComHubspotContactsDataContactsProtos.Type;
    schema: Default<FieldSchema>;
    label?: string;
    description?: string;
    helpText?: string;
    fieldType?: PropertyFieldType;
    options: Default<Option[]>;
    optionsUrl?: string;
    useChirp: Default<boolean>;
    referencedObjectType?: ObjectType;
    externalOptions: Default<boolean>;
    externalOptionsReferenceType?: string;
  };

  export type OutputFieldDefinition = {
    typeDefinition: ComHubspotAutomationplatformFieldCoreDefinition.FieldTypeDefinition;
  };
}

export const ArrayFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.ArrayFieldSchema';
export const ArrayFieldSchemaDiscriminant = 'ARRAY';
export const ArrayFieldSchemaDiscriminantKey = 'type';
export type ArrayFieldSchema = {
  items: FieldSchema;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.ArrayFieldSchema';
} & { type?: 'ARRAY' };

export const BooleanFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.BooleanFieldSchema';
export const BooleanFieldSchemaDiscriminant = 'BOOLEAN';
export const BooleanFieldSchemaDiscriminantKey = 'type';
export type BooleanFieldSchema = {
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.BooleanFieldSchema';
} & { type?: 'BOOLEAN' };

export const DoubleFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.DoubleFieldSchema';
export const DoubleFieldSchemaDiscriminant = 'DOUBLE';
export const DoubleFieldSchemaDiscriminantKey = 'type';
export type DoubleFieldSchema = {
  minimum?: number;
  maximum?: number;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.DoubleFieldSchema';
} & { type?: 'DOUBLE' };

export const FieldSchemaDiscriminantKey = 'type';
export type FieldSchema =
  | IntegerFieldSchema
  | LongFieldSchema
  | DoubleFieldSchema
  | StringFieldSchema
  | BooleanFieldSchema
  | ArrayFieldSchema
  | ObjectFieldSchema
  | UnknownFieldSchema;

export const IntegerFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.IntegerFieldSchema';
export const IntegerFieldSchemaDiscriminant = 'INTEGER';
export const IntegerFieldSchemaDiscriminantKey = 'type';
export type IntegerFieldSchema = {
  minimum?: number;
  maximum?: number;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.IntegerFieldSchema';
} & { type?: 'INTEGER' };

export const LongFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.LongFieldSchema';
export const LongFieldSchemaDiscriminant = 'LONG';
export const LongFieldSchemaDiscriminantKey = 'type';
export type LongFieldSchema = {
  minimum?: number;
  maximum?: number;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.LongFieldSchema';
} & { type?: 'LONG' };

export const ObjectFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.ObjectFieldSchema';
export const ObjectFieldSchemaDiscriminant = 'OBJECT';
export const ObjectFieldSchemaDiscriminantKey = 'type';
export type ObjectFieldSchema = {
  properties: Default<Record<string, FieldSchema>>;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.ObjectFieldSchema';
} & { type?: 'OBJECT' };

export const StringFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.StringFieldSchema';
export const StringFieldSchemaDiscriminant = 'STRING';
export const StringFieldSchemaDiscriminantKey = 'type';
export type StringFieldSchema = {
  format?: StringFormat;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.StringFieldSchema';
} & { type?: 'STRING' };

export type StringFormat =
  | 'DATE_TIME'
  | 'TIME'
  | 'DATE'
  | 'URI'
  | 'OBJECT_COORDINATE'
  | 'MONTH_AND_DAY'
  | 'OBJECT_TYPE'
  | unhandledEnumCase;

export const UnknownFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.UnknownFieldSchema';
export const UnknownFieldSchemaDiscriminant = 'UNKNOWN';
export const UnknownFieldSchemaDiscriminantKey = 'type';
export type UnknownFieldSchema = {
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.UnknownFieldSchema';
} & { type?: 'UNKNOWN' };

export const AppendObjectPropertyValueTypename =
  'com.hubspot.automationplatform.field.core.input.AppendObjectPropertyValue';
export const AppendObjectPropertyValueDiscriminant = 'APPEND_OBJECT_PROPERTY';
export const AppendObjectPropertyValueDiscriminantKey = 'type';
export type AppendObjectPropertyValue = {
  propertyName: string;
  __typename: 'com.hubspot.automationplatform.field.core.input.AppendObjectPropertyValue';
} & { type?: 'APPEND_OBJECT_PROPERTY' };

export const IncrementValueTypename =
  'com.hubspot.automationplatform.field.core.input.IncrementValue';
export const IncrementValueDiscriminant = 'INCREMENT';
export const IncrementValueDiscriminantKey = 'type';
export type IncrementValue = {
  amount: number;
  __typename: 'com.hubspot.automationplatform.field.core.input.IncrementValue';
} & { type?: 'INCREMENT' };

export const InputValueDiscriminantKey = 'type';
export type InputValue =
  | ComHubspotAutomationplatformFieldCoreInput.ObjectPropertyValue
  | ComHubspotAutomationplatformFieldCoreInput.TimestampValue
  | ComHubspotAutomationplatformFieldCoreInput.StaticValue
  | ComHubspotAutomationplatformFieldCoreInput.RelativeDateTimeValue
  | IncrementValue
  | StaticAppendValue
  | AppendObjectPropertyValue
  | ComHubspotAutomationplatformFieldCoreInput.FieldDataValue
  | ComHubspotAutomationplatformFieldCoreInput.FetchedObjectPropertyValue
  | ComHubspotAutomationplatformFieldCoreInput.ActionOutputObjectPropertyValue
  | ComHubspotAutomationplatformFieldCoreInput.EnrollmentEventPropertyValue
  | ComHubspotAutomationplatformFieldCoreInput.EnrollmentDatasetColumnValue
  | ComHubspotAutomationplatformFieldCoreInput.SingleObjectCoordinatesValue
  | ComHubspotAutomationplatformFieldCoreInput.MultiValue
  | ListInputValue
  | MapInputValue
  | ComHubspotAutomationplatformFieldCoreInput.ObjectCoordinatesProviderValue
  | ComHubspotAutomationplatformFieldCoreInput.TemplateValue;

export type InputValueField = {
  fieldKey: string;
  fieldValue: InputValue;
  inputActionName: Default<string>;
};

export type InputVariable = { name: string; value: InputValue };

export const ListInputValueTypename =
  'com.hubspot.automationplatform.field.core.input.ListInputValue';
export const ListInputValueDiscriminant = 'LIST_INPUT_VALUE';
export const ListInputValueDiscriminantKey = 'type';
export type ListInputValue = {
  values: Default<InputValue[]>;
  __typename: 'com.hubspot.automationplatform.field.core.input.ListInputValue';
} & { type?: 'LIST_INPUT_VALUE' };

export const MapInputValueTypename =
  'com.hubspot.automationplatform.field.core.input.MapInputValue';
export const MapInputValueDiscriminant = 'MAP_INPUT_VALUE';
export const MapInputValueDiscriminantKey = 'type';
export type MapInputValue = {
  values: Default<Record<string, InputValue>>;
  __typename: 'com.hubspot.automationplatform.field.core.input.MapInputValue';
} & { type?: 'MAP_INPUT_VALUE' };

export const StaticAppendValueTypename =
  'com.hubspot.automationplatform.field.core.input.StaticAppendValue';
export const StaticAppendValueDiscriminant = 'STATIC_APPEND_VALUE';
export const StaticAppendValueDiscriminantKey = 'type';
export type StaticAppendValue = {
  value: string;
  __typename: 'com.hubspot.automationplatform.field.core.input.StaticAppendValue';
} & { type?: 'STATIC_APPEND_VALUE' };

export namespace ComHubspotAutomationplatformFieldCoreInput {
  export const ActionOutputObjectPropertyValueTypename =
    'com.hubspot.automationplatform.field.core.input.ActionOutputObjectPropertyValue';
  export const ActionOutputObjectPropertyValueDiscriminant =
    'ACTION_OUTPUT_OBJECT_PROPERTY';
  export const ActionOutputObjectPropertyValueDiscriminantKey = 'type';
  export type ActionOutputObjectPropertyValue = {
    propertyToken: string;
    __typename: 'com.hubspot.automationplatform.field.core.input.ActionOutputObjectPropertyValue';
  } & { type?: 'ACTION_OUTPUT_OBJECT_PROPERTY' };

  export const EnrollmentDatasetColumnValueTypename =
    'com.hubspot.automationplatform.field.core.input.EnrollmentDatasetColumnValue';
  export const EnrollmentDatasetColumnValueDiscriminant =
    'ENROLLMENT_DATASET_COLUMN';
  export const EnrollmentDatasetColumnValueDiscriminantKey = 'type';
  export type EnrollmentDatasetColumnValue = {
    propertyToken: string;
    __typename: 'com.hubspot.automationplatform.field.core.input.EnrollmentDatasetColumnValue';
  } & { type?: 'ENROLLMENT_DATASET_COLUMN' };

  export const EnrollmentEventPropertyValueTypename =
    'com.hubspot.automationplatform.field.core.input.EnrollmentEventPropertyValue';
  export const EnrollmentEventPropertyValueDiscriminant =
    'ENROLLMENT_EVENT_PROPERTY';
  export const EnrollmentEventPropertyValueDiscriminantKey = 'type';
  export type EnrollmentEventPropertyValue = {
    propertyToken: string;
    __typename: 'com.hubspot.automationplatform.field.core.input.EnrollmentEventPropertyValue';
  } & { type?: 'ENROLLMENT_EVENT_PROPERTY' };

  export const FetchedObjectPropertyValueTypename =
    'com.hubspot.automationplatform.field.core.input.FetchedObjectPropertyValue';
  export const FetchedObjectPropertyValueDiscriminant =
    'FETCHED_OBJECT_PROPERTY';
  export const FetchedObjectPropertyValueDiscriminantKey = 'type';
  export type FetchedObjectPropertyValue = {
    propertyToken: string;
    __typename: 'com.hubspot.automationplatform.field.core.input.FetchedObjectPropertyValue';
  } & { type?: 'FETCHED_OBJECT_PROPERTY' };

  export const FieldDataValueTypename =
    'com.hubspot.automationplatform.field.core.input.FieldDataValue';
  export const FieldDataValueDiscriminant = 'FIELD_DATA';
  export const FieldDataValueDiscriminantKey = 'type';
  export type FieldDataValue = {
    identifier: FieldDataIdentifier;
    __typename: 'com.hubspot.automationplatform.field.core.input.FieldDataValue';
  } & { type?: 'FIELD_DATA' };

  export const MultiValueTypename =
    'com.hubspot.automationplatform.field.core.input.MultiValue';
  export const MultiValueDiscriminant = 'MULTI_VALUE';
  export const MultiValueDiscriminantKey = 'type';
  export type MultiValue = {
    value: Default<string[]>;
    __typename: 'com.hubspot.automationplatform.field.core.input.MultiValue';
  } & { type?: 'MULTI_VALUE' };

  export const ObjectCoordinatesProviderValueTypename =
    'com.hubspot.automationplatform.field.core.input.ObjectCoordinatesProviderValue';
  export const ObjectCoordinatesProviderValueDiscriminant =
    'OBJECT_COORDINATES_PROVIDER';
  export const ObjectCoordinatesProviderValueDiscriminantKey = 'type';
  export type ObjectCoordinatesProviderValue = {
    source: DataSourceType;
    sourceId?: number;
    fieldName?: string;
    __typename: 'com.hubspot.automationplatform.field.core.input.ObjectCoordinatesProviderValue';
  } & { type?: 'OBJECT_COORDINATES_PROVIDER' };

  export const ObjectPropertyValueTypename =
    'com.hubspot.automationplatform.field.core.input.ObjectPropertyValue';
  export const ObjectPropertyValueDiscriminant = 'OBJECT_PROPERTY';
  export const ObjectPropertyValueDiscriminantKey = 'type';
  export type ObjectPropertyValue = {
    propertyName: Default<string>;
    __typename: 'com.hubspot.automationplatform.field.core.input.ObjectPropertyValue';
  } & { type?: 'OBJECT_PROPERTY' };

  export const RelativeDateTimeValueTypename =
    'com.hubspot.automationplatform.field.core.input.RelativeDateTimeValue';
  export const RelativeDateTimeValueDiscriminant = 'RELATIVE_DATETIME';
  export const RelativeDateTimeValueDiscriminantKey = 'type';
  export type RelativeDateTimeValue = {
    timeDelay: TimeDelay;
    __typename: 'com.hubspot.automationplatform.field.core.input.RelativeDateTimeValue';
  } & { type?: 'RELATIVE_DATETIME' };

  export const SingleObjectCoordinatesValueTypename =
    'com.hubspot.automationplatform.field.core.input.SingleObjectCoordinatesValue';
  export const SingleObjectCoordinatesValueDiscriminant =
    'SINGLE_OBJECT_COORDINATES';
  export const SingleObjectCoordinatesValueDiscriminantKey = 'type';
  export type SingleObjectCoordinatesValue = {
    coordinatesToken: string;
    __typename: 'com.hubspot.automationplatform.field.core.input.SingleObjectCoordinatesValue';
  } & { type?: 'SINGLE_OBJECT_COORDINATES' };

  export const StaticValueTypename =
    'com.hubspot.automationplatform.field.core.input.StaticValue';
  export const StaticValueDiscriminant = 'STATIC_VALUE';
  export const StaticValueDiscriminantKey = 'type';
  export type StaticValue = {
    value: Default<string>;
    __typename: 'com.hubspot.automationplatform.field.core.input.StaticValue';
  } & { type?: 'STATIC_VALUE' };

  export const TemplateValueTypename =
    'com.hubspot.automationplatform.field.core.input.TemplateValue';
  export const TemplateValueDiscriminant = 'TEMPLATE_VALUE';
  export const TemplateValueDiscriminantKey = 'type';
  export type TemplateValue = {
    value: Default<string>;
    __typename: 'com.hubspot.automationplatform.field.core.input.TemplateValue';
  } & { type?: 'TEMPLATE_VALUE' };

  export const TimestampValueTypename =
    'com.hubspot.automationplatform.field.core.input.TimestampValue';
  export const TimestampValueDiscriminant = 'TIMESTAMP';
  export const TimestampValueDiscriminantKey = 'type';
  export type TimestampValue = {
    __typename: 'com.hubspot.automationplatform.field.core.input.TimestampValue';
  } & { type?: 'TIMESTAMP' };
}

export type NotificationDeliveryMethod =
  | 'APP'
  | 'EMAIL'
  | 'MOBILE'
  | 'SLACK'
  | unhandledEnumCase;

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type StandardHttpMethod =
  | 'CONNECT'
  | 'DELETE'
  | 'GET'
  | 'HEAD'
  | 'OPTIONS'
  | 'PATCH'
  | 'POST'
  | 'PUT'
  | 'TRACE'
  | unhandledEnumCase;

export type ObjectType =
  | 'CONTACT'
  | 'COMPANY'
  | 'DEAL'
  | 'ENGAGEMENT'
  | 'TICKET'
  | 'OWNER'
  | 'PRODUCT'
  | 'LINE_ITEM'
  | 'BET_DELIVERABLE_SERVICE'
  | 'CONTENT'
  | 'CONVERSATION'
  | 'BET_ALERT'
  | 'PORTAL'
  | 'QUOTE'
  | 'FORM_SUBMISSION_INBOUNDDB'
  | 'QUOTA'
  | 'UNSUBSCRIBE'
  | 'COMMUNICATION'
  | 'FEEDBACK_SUBMISSION'
  | 'ATTRIBUTION'
  | 'SALESFORCE_SYNC_ERROR'
  | 'RESTORABLE_CRM_OBJECT'
  | 'HUB'
  | 'LANDING_PAGE'
  | 'PRODUCT_OR_FOLDER'
  | 'TASK'
  | 'FORM'
  | 'MARKETING_EMAIL'
  | 'AD_ACCOUNT'
  | 'AD_CAMPAIGN'
  | 'AD_GROUP'
  | 'AD'
  | 'KEYWORD'
  | 'CAMPAIGN'
  | 'SOCIAL_CHANNEL'
  | 'SOCIAL_POST'
  | 'SITE_PAGE'
  | 'BLOG_POST'
  | 'IMPORT'
  | 'EXPORT'
  | 'CTA'
  | 'TASK_TEMPLATE'
  | 'AUTOMATION_PLATFORM_FLOW'
  | 'OBJECT_LIST'
  | 'NOTE'
  | 'MEETING_EVENT'
  | 'CALL'
  | 'EMAIL'
  | 'PUBLISHING_TASK'
  | 'CONVERSATION_SESSION'
  | 'CONTACT_CREATE_ATTRIBUTION'
  | 'INVOICE'
  | 'MARKETING_EVENT'
  | 'CONVERSATION_INBOX'
  | 'CHATFLOW'
  | 'MEDIA_BRIDGE'
  | 'SEQUENCE'
  | 'SEQUENCE_STEP'
  | 'FORECAST'
  | 'SNIPPET'
  | 'TEMPLATE'
  | 'DEAL_CREATE_ATTRIBUTION'
  | 'QUOTE_TEMPLATE'
  | 'QUOTE_MODULE'
  | 'QUOTE_MODULE_FIELD'
  | 'QUOTE_FIELD'
  | 'SEQUENCE_ENROLLMENT'
  | 'SUBSCRIPTION'
  | 'ACCEPTANCE_TEST'
  | 'SOCIAL_BROADCAST'
  | 'DEAL_SPLIT'
  | 'DEAL_REGISTRATION'
  | 'GOAL_TARGET'
  | 'GOAL_TARGET_GROUP'
  | 'PORTAL_OBJECT_SYNC_MESSAGE'
  | 'FILE_MANAGER_FILE'
  | 'FILE_MANAGER_FOLDER'
  | 'SEQUENCE_STEP_ENROLLMENT'
  | 'APPROVAL'
  | 'APPROVAL_STEP'
  | 'CTA_VARIANT'
  | 'SALES_DOCUMENT'
  | 'DISCOUNT'
  | 'FEE'
  | 'TAX'
  | 'MARKETING_CALENDAR'
  | 'PERMISSIONS_TESTING'
  | 'PRIVACY_SCANNER_COOKIE'
  | 'DATA_SYNC_STATE'
  | 'WEB_INTERACTIVE'
  | 'PLAYBOOK'
  | 'FOLDER'
  | 'PLAYBOOK_QUESTION'
  | 'PLAYBOOK_SUBMISSION'
  | 'PLAYBOOK_SUBMISSION_ANSWER'
  | 'COMMERCE_PAYMENT'
  | 'GSC_PROPERTY'
  | 'SOX_PROTECTED_DUMMY_TYPE'
  | 'BLOG_LISTING_PAGE'
  | 'QUARANTINED_SUBMISSION'
  | 'PAYMENT_SCHEDULE'
  | 'PAYMENT_SCHEDULE_INSTALLMENT'
  | 'MARKETING_CAMPAIGN_UTM'
  | 'DISCOUNT_TEMPLATE'
  | 'DISCOUNT_CODE'
  | 'FEEDBACK_SURVEY'
  | 'CMS_URL'
  | 'SALES_TASK'
  | 'SALES_WORKLOAD'
  | 'USER'
  | 'POSTAL_MAIL'
  | 'SCHEMAS_BACKEND_TEST'
  | 'PAYMENT_LINK'
  | 'SUBMISSION_TAG'
  | 'CAMPAIGN_STEP'
  | 'SCHEDULING_PAGE'
  | 'SOX_PROTECTED_TEST_TYPE'
  | 'ORDER'
  | 'MARKETING_SMS'
  | 'PARTNER_ACCOUNT'
  | 'CAMPAIGN_TEMPLATE'
  | 'CAMPAIGN_TEMPLATE_STEP'
  | 'PLAYLIST'
  | 'CLIP'
  | 'CAMPAIGN_BUDGET_ITEM'
  | 'CAMPAIGN_SPEND_ITEM'
  | 'MIC'
  | 'CONTENT_AUDIT'
  | 'CONTENT_AUDIT_PAGE'
  | 'PLAYLIST_FOLDER'
  | 'LEAD'
  | 'ABANDONED_CART'
  | 'EXTERNAL_WEB_URL'
  | 'VIEW'
  | 'VIEW_BLOCK'
  | 'ROSTER'
  | 'CART'
  | 'AUTOMATION_PLATFORM_FLOW_ACTION'
  | 'SOCIAL_PROFILE'
  | 'PARTNER_CLIENT'
  | 'ROSTER_MEMBER'
  | 'MARKETING_EVENT_ATTENDANCE'
  | 'ALL_PAGES'
  | 'AI_FORECAST'
  | 'CRM_PIPELINES_DUMMY_TYPE'
  | 'KNOWLEDGE_ARTICLE'
  | 'PROPERTY_INFO'
  | 'DATA_PRIVACY_CONSENT'
  | 'GOAL_TEMPLATE'
  | 'SCORE_CONFIGURATION'
  | 'AUDIENCE'
  | 'PARTNER_CLIENT_REVENUE'
  | 'AUTOMATION_JOURNEY'
  | 'COMBO_EVENT_CONFIGURATION'
  | 'CRM_OBJECTS_DUMMY_TYPE'
  | 'CASE_STUDY'
  | 'SERVICE'
  | 'PODCAST_EPISODE'
  | 'PARTNER_SERVICE'
  | 'PROSPECTING_AGENT_CONTACT_ASSIGNMENT'
  | 'UNKNOWN'
  | unhandledEnumCase;

export type Option = {
  hidden?: boolean;
  displayOrder?: number;
  doubleData?: number;
  description?: string;
  readOnly?: boolean;
  label?: string;
  value?: string;
};

export namespace ComHubspotContactsDataContactsProtos {
  export type Type =
    | 'string'
    | 'number'
    | 'bool'
    | 'datetime'
    | 'enumeration'
    | 'date'
    | 'phone_number'
    | 'currency_number'
    | 'json'
    | 'object_coordinates'
    | 'time_range'
    | unhandledEnumCase;
}

export type DateDisplayHint =
  | 'absolute'
  | 'absolute_with_relative'
  | 'time_since'
  | 'time_until'
  | unhandledEnumCase;

export type OfficeHours = { day: Day; startMinute: number; endMinute: number };

export type Day =
  | 'MON_FRI'
  | 'SAT_SUN'
  | 'EVERY_DAY'
  | 'SUNDAY'
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | unhandledEnumCase;

export type ObjectTypeIdProto = { innerId?: number; metaTypeId?: number };

export type LineItemFromProductCreateRequest = {
  properties: Default<PropertyValue[]>;
};

export type Direction = 'FORWARD' | 'BACKWARD' | unhandledEnumCase;

export type FilterDateTimeFormat =
  | 'EPOCH_MILLISECONDS'
  | 'DATE'
  | 'RELATIVE_TIME_DURATION'
  | unhandledEnumCase;

export type FilterOperator =
  | 'EQ'
  | 'NEQ'
  | 'LT'
  | 'LTE'
  | 'GT'
  | 'GTE'
  | 'BETWEEN'
  | 'IN'
  | 'NOT_IN'
  | 'HAS_PROPERTY'
  | 'NOT_HAS_PROPERTY'
  | 'ROLLING_DATE_RANGE'
  | 'TIME_UNIT_TO_DATE'
  | 'BEFORE_ROLLING_DATE_POINT'
  | 'AFTER_ROLLING_DATE_POINT'
  | 'LT_X_DAYS'
  | 'GT_X_DAYS'
  | 'CONTAINS_ALL'
  | 'DOES_NOT_CONTAIN_ALL'
  | 'IS_EXACTLY'
  | 'IS_NOT_EXACTLY'
  | 'EQ_PROPERTY'
  | 'NEQ_PROPERTY'
  | 'LT_PROPERTY'
  | 'LTE_PROPERTY'
  | 'GT_PROPERTY'
  | 'GTE_PROPERTY'
  | unhandledEnumCase;

export type FilterTimeUnit =
  | 'SECOND'
  | 'MINUTE'
  | 'HOUR'
  | 'DAY'
  | 'WEEK'
  | 'MONTH'
  | 'QUARTER'
  | 'YEAR'
  | unhandledEnumCase;

export type Sort = {
  property: string;
  missing?: string;
  order: Default<SortOrder>;
};

export type SortOrder = 'ASC' | 'DESC' | unhandledEnumCase;

export const RoutingRuleDefinitionDiscriminantKey = '@type';
export type RoutingRuleDefinition =
  | UnassignedRouting
  | UsersAndTeamsRouting
  | InboxUsersRouting
  | BotRouting
  | OwnerRouting
  | QuoteOwnerRouting
  | SkillRouting
  | AiChatbotRouting
  | TeamsOnlyRouting
  | WaitlistRouting
  | CustomerAgentRouting
  | SpecifiedHoursRouting
  | CustomerAgentComplexRouting
  | SkillBasedRouting
  | WorkflowRouting;

export type RuleWithPercentage = {
  rule: RoutingRuleDefinition;
  percentage: number;
};

export const AiChatbotRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.AiChatbotRouting';
export const AiChatbotRoutingDiscriminant = 'AI_CHATBOT';
export const AiChatbotRoutingDiscriminantKey = '@type';
export type AiChatbotRouting = {
  aiChatbotId: number;
  fallback: RoutingRuleDefinition;
  fallbackV2?: RoutingRuleDefinition;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.AiChatbotRouting';
} & { '@type'?: 'AI_CHATBOT' };

export const BotRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.BotRouting';
export const BotRoutingDiscriminant = 'BOT';
export const BotRoutingDiscriminantKey = '@type';
export type BotRouting = {
  botId: number;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.BotRouting';
} & { '@type'?: 'BOT' };

export const CustomerAgentComplexRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.CustomerAgentComplexRouting';
export const CustomerAgentComplexRoutingDiscriminant = 'CUSTOMER_AGENT_COMPLEX';
export const CustomerAgentComplexRoutingDiscriminantKey = '@type';
export type CustomerAgentComplexRouting = {
  timezoneId?: string;
  hoursByRule: Default<RuleWithHours[]>;
  percentageByRule: Default<RuleWithPercentage[]>;
  defaultRule: RoutingRuleDefinition;
  targeting?: DeploymentTarget;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.CustomerAgentComplexRouting';
} & { '@type'?: 'CUSTOMER_AGENT_COMPLEX' };

export const CustomerAgentRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.CustomerAgentRouting';
export const CustomerAgentRoutingDiscriminant = 'CUSTOMER_AGENT';
export const CustomerAgentRoutingDiscriminantKey = '@type';
export type CustomerAgentRouting = {
  aiAgentId: number;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.CustomerAgentRouting';
} & { '@type'?: 'CUSTOMER_AGENT' };

export type Distribution =
  | 'RANDOM'
  | 'BALANCED'
  | 'ROUND_ROBIN'
  | unhandledEnumCase;

export const InboxUsersRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.InboxUsersRouting';
export const InboxUsersRoutingDiscriminant = 'INBOX_USERS';
export const InboxUsersRoutingDiscriminantKey = '@type';
export type InboxUsersRouting = {
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.InboxUsersRouting';
} & { '@type'?: 'INBOX_USERS' };

export const OwnerRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.OwnerRouting';
export const OwnerRoutingDiscriminant = 'OWNER';
export const OwnerRoutingDiscriminantKey = '@type';
export type OwnerRouting = {
  fallback: RoutingRuleDefinition;
  fallbackV2?: RoutingRuleDefinition;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.OwnerRouting';
} & { '@type'?: 'OWNER' };

export const QuoteOwnerRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.QuoteOwnerRouting';
export const QuoteOwnerRoutingDiscriminant = 'QUOTE_OWNER';
export const QuoteOwnerRoutingDiscriminantKey = '@type';
export type QuoteOwnerRouting = {
  fallback: RoutingRuleDefinition;
  fallbackV2?: RoutingRuleDefinition;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.QuoteOwnerRouting';
} & { '@type'?: 'QUOTE_OWNER' };

export type RotationMethod =
  | 'RANDOM'
  | 'LEAST_BUSY'
  | 'ROUND_ROBIN'
  | unhandledEnumCase;

export const SkillBasedRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.SkillBasedRouting';
export const SkillBasedRoutingDiscriminant = 'SKILL_BASED_ROUTING';
export const SkillBasedRoutingDiscriminantKey = '@type';
export type SkillBasedRouting = {
  workflowId: number;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.SkillBasedRouting';
} & { '@type'?: 'SKILL_BASED_ROUTING' };

export const SkillRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.SkillRouting';
export const SkillRoutingDiscriminant = 'SKILL';
export const SkillRoutingDiscriminantKey = '@type';
export type SkillRouting = {
  skills: Default<Skill[]>;
  skillMatchMode: Default<SkillMatchMode>;
  usersAndTeamsRule?: UsersAndTeamsRouting;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.SkillRouting';
} & { '@type'?: 'SKILL' };

export const SpecifiedHoursRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.SpecifiedHoursRouting';
export const SpecifiedHoursRoutingDiscriminant = 'SPECIFIED_HOURS';
export const SpecifiedHoursRoutingDiscriminantKey = '@type';
export type SpecifiedHoursRouting = {
  timezoneId: string;
  hoursByRule: Default<RuleWithHours[]>;
  defaultRule: RoutingRuleDefinition;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.SpecifiedHoursRouting';
} & { '@type'?: 'SPECIFIED_HOURS' };

export const TeamsOnlyRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.TeamsOnlyRouting';
export const TeamsOnlyRoutingDiscriminant = 'TEAMS_ONLY';
export const TeamsOnlyRoutingDiscriminantKey = '@type';
export type TeamsOnlyRouting = {
  teamIds: Default<number[]>;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.TeamsOnlyRouting';
} & { '@type'?: 'TEAMS_ONLY' };

export const UnassignedRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.UnassignedRouting';
export const UnassignedRoutingDiscriminant = 'UNASSIGNED';
export const UnassignedRoutingDiscriminantKey = '@type';
export type UnassignedRouting = {
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.UnassignedRouting';
} & { '@type'?: 'UNASSIGNED' };

export const UsersAndTeamsRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.UsersAndTeamsRouting';
export const UsersAndTeamsRoutingDiscriminant = 'USERS_AND_TEAMS';
export const UsersAndTeamsRoutingDiscriminantKey = '@type';
export type UsersAndTeamsRouting = {
  userIds: Default<number[]>;
  teamIds: Default<number[]>;
  fallback?: RoutingRuleDefinition;
  fallbackV2?: RoutingRuleDefinition;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.UsersAndTeamsRouting';
} & { '@type'?: 'USERS_AND_TEAMS' };

export const WaitlistRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.WaitlistRouting';
export const WaitlistRoutingDiscriminant = 'WAITLIST';
export const WaitlistRoutingDiscriminantKey = '@type';
export type WaitlistRouting = {
  waitlistRoutingTargets: WaitlistRoutingTargets;
  distribution: Default<Distribution>;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  __typename: 'com.hubspot.cv.assignments.core.routing.WaitlistRouting';
} & { '@type'?: 'WAITLIST' };

export const WorkflowRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.WorkflowRouting';
export const WorkflowRoutingDiscriminant = 'WORKFLOW_ROUTING';
export const WorkflowRoutingDiscriminantKey = '@type';
export type WorkflowRouting = {
  workflowId: number;
  shouldFilterToAvailable: Default<boolean>;
  /** @deprecated */
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.WorkflowRouting';
} & { '@type'?: 'WORKFLOW_ROUTING' };

export type DeploymentTarget = {
  includedSegmentIds: Default<number[]>;
  excludedSegmentIds: Default<number[]>;
};

export type Skill = { category: string; categoryLabel?: string; value: string };

export type SkillMatchMode = 'ALL' | 'ANY' | unhandledEnumCase;

export type WaitlistRoutingTargets = {
  /** @deprecated */
  teamIds: Default<number[]>;
  /** @deprecated */
  userIds: Default<number[]>;
  /** @deprecated */
  skillValues: Default<string[]>;
  /** @deprecated */
  skills: Default<Skill[]>;
  routingRuleDefinition: RoutingRuleDefinition;
  workflowId?: number;
  actionId?: number;
};

export type RuleWithHours = {
  rule: RoutingRuleDefinition;
  hours: Default<OfficeHours[]>;
};

export type SubscriptionLegalBasisType =
  | 'LEGITIMATE_INTEREST_PQL'
  | 'LEGITIMATE_INTEREST_CLIENT'
  | 'PERFORMANCE_OF_CONTRACT'
  | 'CONSENT_WITH_NOTICE'
  | 'NON_GDPR'
  | 'PROCESS_AND_STORE'
  | 'LEGITIMATE_INTEREST_OTHER'
  | unhandledEnumCase;

export namespace ComHubspotEmailEmailProtos {
  export type OptState = 'OPT_IN' | 'OPT_OUT' | 'NOT_OPTED' | unhandledEnumCase;
}

export type Priority = 'NONE' | 'HIGH' | 'MEDIUM' | 'LOW' | unhandledEnumCase;

export type TaskType =
  | 'CALL'
  | 'MEETING'
  | 'EMAIL'
  | 'TODO'
  | 'LINKED_IN'
  | 'LINKED_IN_CONNECT'
  | 'LINKED_IN_MESSAGE'
  | unhandledEnumCase;

export type AssociationCategory =
  | 'HUBSPOT_DEFINED'
  | 'USER_DEFINED'
  | 'INTEGRATOR_DEFINED'
  | 'WORK'
  | unhandledEnumCase;

export type AssociationSpec = {
  associationCategory: AssociationCategory;
  associationTypeId: number;
};

export const AndFilterBranchTypename =
  'com.hubspot.inbounddb.listseg.AndFilterBranch';
export const AndFilterBranchDiscriminant = 'AND';
export const AndFilterBranchDiscriminantKey = 'filterBranchType';
export type AndFilterBranch = {
  filterBranches: Default<FilterBranch[]>;
  filters: Default<Filter[]>;
  filterBranchId?: string;
  filterInsightsId?: number;
  __typename: 'com.hubspot.inbounddb.listseg.AndFilterBranch';
} & { filterBranchType?: 'AND' };

export const AssociationFilterBranchTypename =
  'com.hubspot.inbounddb.listseg.AssociationFilterBranch';
export const AssociationFilterBranchDiscriminant = 'ASSOCIATION';
export const AssociationFilterBranchDiscriminantKey = 'filterBranchType';
export type AssociationFilterBranch = {
  associationCategory: AssociationCategory;
  associationTypeId: number;
  /** @deprecated */
  deprecatedLegacyObjectType?: ObjectType;
  objectTypeId: Default<string>;
  operator: ComHubspotInbounddbListsegFiltersAssociationInListFilterIF.SupportedOperator;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  associationListId?: number;
  frameworkFilterId?: number;
  filterBranchOperator: FilterBranchOperator;
  filterBranches: Default<FilterBranch[]>;
  filters: Default<Filter[]>;
  filterBranchId?: string;
  filterInsightsId?: number;
  __typename: 'com.hubspot.inbounddb.listseg.AssociationFilterBranch';
} & { filterBranchType?: 'ASSOCIATION' };

export const FilterBranchDiscriminantKey = 'filterBranchType';
export type FilterBranch =
  | AndFilterBranch
  | OrFilterBranch
  | AssociationFilterBranch
  | NotAllFilterBranch
  | NotAnyFilterBranch
  | PropertyAssociationFilterBranch
  | UnifiedEventsFilterBranch
  | RestrictedFilterBranch;

export type FilterBranchOperator =
  | 'AND'
  | 'OR'
  | 'NOT_ALL'
  | 'NOT_ANY'
  | 'RESTRICTED'
  | unhandledEnumCase;

export const NotAllFilterBranchTypename =
  'com.hubspot.inbounddb.listseg.NotAllFilterBranch';
export const NotAllFilterBranchDiscriminant = 'NOT_ALL';
export const NotAllFilterBranchDiscriminantKey = 'filterBranchType';
export type NotAllFilterBranch = {
  filterBranches: Default<FilterBranch[]>;
  filters: Default<Filter[]>;
  filterBranchId?: string;
  filterInsightsId?: number;
  __typename: 'com.hubspot.inbounddb.listseg.NotAllFilterBranch';
} & { filterBranchType?: 'NOT_ALL' };

export const NotAnyFilterBranchTypename =
  'com.hubspot.inbounddb.listseg.NotAnyFilterBranch';
export const NotAnyFilterBranchDiscriminant = 'NOT_ANY';
export const NotAnyFilterBranchDiscriminantKey = 'filterBranchType';
export type NotAnyFilterBranch = {
  filterBranches: Default<FilterBranch[]>;
  filters: Default<Filter[]>;
  filterBranchId?: string;
  filterInsightsId?: number;
  __typename: 'com.hubspot.inbounddb.listseg.NotAnyFilterBranch';
} & { filterBranchType?: 'NOT_ANY' };

export const OrFilterBranchTypename =
  'com.hubspot.inbounddb.listseg.OrFilterBranch';
export const OrFilterBranchDiscriminant = 'OR';
export const OrFilterBranchDiscriminantKey = 'filterBranchType';
export type OrFilterBranch = {
  filterBranches: Default<FilterBranch[]>;
  filters: Default<Filter[]>;
  filterBranchId?: string;
  filterInsightsId?: number;
  __typename: 'com.hubspot.inbounddb.listseg.OrFilterBranch';
} & { filterBranchType?: 'OR' };

export const PropertyAssociationFilterBranchTypename =
  'com.hubspot.inbounddb.listseg.PropertyAssociationFilterBranch';
export const PropertyAssociationFilterBranchDiscriminant =
  'PROPERTY_ASSOCIATION';
export const PropertyAssociationFilterBranchDiscriminantKey =
  'filterBranchType';
export type PropertyAssociationFilterBranch = {
  propertyWithObjectId: string;
  /** @deprecated */
  deprecatedLegacyObjectType?: ObjectType;
  objectTypeId: Default<string>;
  operator: ComHubspotInbounddbListsegFiltersAssociationInListFilterIF.SupportedOperator;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  associationListId?: number;
  frameworkFilterId?: number;
  filterBranchOperator: FilterBranchOperator;
  filterBranches: Default<FilterBranch[]>;
  filters: Default<Filter[]>;
  filterBranchId?: string;
  filterInsightsId?: number;
  __typename: 'com.hubspot.inbounddb.listseg.PropertyAssociationFilterBranch';
} & { filterBranchType?: 'PROPERTY_ASSOCIATION' };

export const RestrictedFilterBranchTypename =
  'com.hubspot.inbounddb.listseg.RestrictedFilterBranch';
export const RestrictedFilterBranchDiscriminant = 'RESTRICTED';
export const RestrictedFilterBranchDiscriminantKey = 'filterBranchType';
export type RestrictedFilterBranch = {
  restrictedReason?: RestrictedReason;
  filterBranches: Default<FilterBranch[]>;
  filters: Default<Filter[]>;
  filterBranchId?: string;
  filterInsightsId?: number;
  __typename: 'com.hubspot.inbounddb.listseg.RestrictedFilterBranch';
} & { filterBranchType?: 'RESTRICTED' };

export type RestrictedReason =
  | 'NOT_ALLOWED'
  | 'NOT_REQUESTED'
  | unhandledEnumCase;

export const UnifiedEventsFilterBranchTypename =
  'com.hubspot.inbounddb.listseg.UnifiedEventsFilterBranch';
export const UnifiedEventsFilterBranchDiscriminant = 'UNIFIED_EVENTS';
export const UnifiedEventsFilterBranchDiscriminantKey = 'filterBranchType';
export type UnifiedEventsFilterBranch = {
  eventTypeId: string;
  coalescingRefineBy?: CoalescingRefineBy;
  pruningRefineBy?: PruningRefineBy;
  filterBranches: Default<FilterBranch[]>;
  filters: Default<Filter[]>;
  filterBranchId?: string;
  filterInsightsId?: number;
  __typename: 'com.hubspot.inbounddb.listseg.UnifiedEventsFilterBranch';
} & { filterBranchType?: 'UNIFIED_EVENTS' };

export const AssociationInListFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.AssociationInListFilter';
export const AssociationInListFilterDiscriminant = 'ASSOCIATION';
export const AssociationInListFilterDiscriminantKey = 'filterType';
export type AssociationInListFilter = {
  associationTypeId: number;
  associationCategory: AssociationCategory;
  multiHop?: boolean;
  operator: ComHubspotInbounddbListsegFiltersAssociationInListFilterIF.SupportedOperator;
  listId: number;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.AssociationInListFilter';
} & { filterType?: 'ASSOCIATION' };

export const FilterDiscriminantKey = 'filterType';
export type Filter =
  | PropertyFilter
  | AssociationInListFilter
  | PageViewAnalyticsFilter
  | CtaAnalyticsFilter
  | EventAnalyticsFilter
  | FormSubmissionFilter
  | FormSubmissionOnPageFilter
  | IntegrationEventFilter
  | EmailSubscriptionFilter
  | CommunicationSubscriptionFilter
  | CampaignInfluencedFilter
  | SurveyMonkeyFilter
  | SurveyMonkeyValueFilter
  | WebinarFilter
  | EmailEventFilter
  | PrivacyAnalyticsFilter
  | AdsSearchFilter
  | AdsTimeFilter
  | InListFilter
  | NumAssociationsFilter
  | UnifiedEventsFilter
  | PropertyAssociationInListFilter
  | ConstantFilter
  | UnifiedEventsInListFilter
  | DatasetFilter
  | MultiInListFilter;

export type PropertyAspect = { aspect: Aspect; qualifier?: string };

export const PropertyAssociationInListFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.PropertyAssociationInListFilter';
export const PropertyAssociationInListFilterDiscriminant =
  'PROPERTY_ASSOCIATION';
export const PropertyAssociationInListFilterDiscriminantKey = 'filterType';
export type PropertyAssociationInListFilter = {
  propertyWithObjectId: string;
  operator: ComHubspotInbounddbListsegFiltersAssociationInListFilterIF.SupportedOperator;
  listId: number;
  toObjectTypeId?: string;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.PropertyAssociationInListFilter';
} & { filterType?: 'PROPERTY_ASSOCIATION' };

export const PropertyFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.PropertyFilter';
export const PropertyFilterDiscriminant = 'PROPERTY';
export const PropertyFilterDiscriminantKey = 'filterType';
export type PropertyFilter = {
  property: string;
  operation: PropertyFilterOperation;
  context?: PropertyFilterContext;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.PropertyFilter';
} & { filterType?: 'PROPERTY' };

export type PropertyFilterContext = { objectTypeId: string };

export const PropertyFilterOperationDiscriminantKey = 'propertyType';
export type PropertyFilterOperation =
  | BoolPropertyOperation
  | NumberPropertyOperation
  | StringPropertyOperation
  | DateTimePropertyOperation
  | RangedDatePropertyOperation
  | ComparativeDatePropertyOperation
  | ComparativeBoolPropertyOperation
  | ComparativeNumberPropertyOperation
  | ComparativeStringPropertyOperation
  | ComparativePropertyUpdatedOperation
  | RollingDateRangePropertyOperation
  | RollingPropertyUpdatedOperation
  | EnumerationPropertyOperation
  | AllPropertyTypesOperation
  | RangedNumberPropertyOperation
  | MultiStringPropertyOperation
  | DatePropertyOperation
  | CalendarDatePropertyOperation
  | TimePointOperation
  | RangedTimeOperation
  | RegexPropertyOperation;

export type RollingDateRangeOperator =
  | 'IS_LESS_THAN_X_DAYS_AGO'
  | 'IS_MORE_THAN_X_DAYS_AGO'
  | 'IS_LESS_THAN_X_DAYS_FROM_NOW'
  | 'IS_MORE_THAN_X_DAYS_FROM_NOW'
  | unhandledEnumCase;

export namespace ComHubspotInbounddbListsegFiltersAssociationInListFilterIF {
  export type SupportedOperator = 'IN_LIST' | 'NOT_IN_LIST' | unhandledEnumCase;
}

export type Aspect = 'TIMERANGE_START' | 'TIMERANGE_END' | unhandledEnumCase;

export const AdsSearchFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.adsfilter.AdsSearchFilter';
export const AdsSearchFilterDiscriminant = 'ADS_SEARCH';
export const AdsSearchFilterDiscriminantKey = 'filterType';
export type AdsSearchFilter = {
  entityType: EntityType;
  searchTermType: AdsListSegSearchTermType;
  searchTerms: Default<string[]>;
  adNetwork: AdNetwork;
  operator: ComHubspotInbounddbListsegFiltersAdsfilterAdsSearchFilterIF.SupportedOperator;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.adsfilter.AdsSearchFilter';
} & { filterType?: 'ADS_SEARCH' };

export const AdsTimeFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.adsfilter.AdsTimeFilter';
export const AdsTimeFilterDiscriminant = 'ADS_TIME';
export const AdsTimeFilterDiscriminantKey = 'filterType';
export type AdsTimeFilter = {
  pruningRefineBy: PruningRefineBy;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.adsfilter.AdsTimeFilter';
} & { filterType?: 'ADS_TIME' };

export type AdNetwork =
  | 'ADWORDS'
  | 'FACEBOOK'
  | 'LINKEDIN'
  | 'TIKTOK'
  | 'BING'
  | 'REDDIT'
  | 'CHATGPT'
  | 'ALL'
  | unhandledEnumCase;

export type AdsListSegSearchTermType =
  | 'ID'
  | 'NAME'
  | 'AD_TYPE'
  | unhandledEnumCase;

export type EntityType =
  | 'KEYWORD'
  | 'ADGROUP'
  | 'AD'
  | 'CAMPAIGN'
  | unhandledEnumCase;

export namespace ComHubspotInbounddbListsegFiltersAdsfilterAdsSearchFilterIF {
  export type SupportedOperator =
    | 'CONTAINS'
    | 'IS_EQUAL_TO'
    | 'ENDS_WITH'
    | 'STARTS_WITH'
    | 'IS_KNOWN'
    | unhandledEnumCase;
}

export const CtaAnalyticsFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.analyticsfilter.CtaAnalyticsFilter';
export const CtaAnalyticsFilterDiscriminant = 'CTA';
export const CtaAnalyticsFilterDiscriminantKey = 'filterType';
export type CtaAnalyticsFilter = {
  operator: ComHubspotInbounddbListsegFiltersAnalyticsfilterCtaAnalyticsFilterIF.SupportedOperator;
  ctaName: string;
  pruningRefineBy: Default<PruningRefineBy>;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  refineBy: Default<RefineBy>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.analyticsfilter.CtaAnalyticsFilter';
} & { filterType?: 'CTA' };

export const EventAnalyticsFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.analyticsfilter.EventAnalyticsFilter';
export const EventAnalyticsFilterDiscriminant = 'EVENT';
export const EventAnalyticsFilterDiscriminantKey = 'filterType';
export type EventAnalyticsFilter = {
  operator: ComHubspotInbounddbListsegFiltersAnalyticsfilterEventAnalyticsFilterIF.SupportedOperator;
  eventId: string;
  pruningRefineBy: Default<PruningRefineBy>;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  refineBy: Default<RefineBy>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.analyticsfilter.EventAnalyticsFilter';
} & { filterType?: 'EVENT' };

export const PageViewAnalyticsFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.analyticsfilter.PageViewAnalyticsFilter';
export const PageViewAnalyticsFilterDiscriminant = 'PAGE_VIEW';
export const PageViewAnalyticsFilterDiscriminantKey = 'filterType';
export type PageViewAnalyticsFilter = {
  operator: ComHubspotInbounddbListsegFiltersAnalyticsfilterPageViewAnalyticsFilterIF.SupportedOperator;
  pageUrl: string;
  enableTracking: Default<boolean>;
  pruningRefineBy: Default<PruningRefineBy>;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  refineBy: Default<RefineBy>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.analyticsfilter.PageViewAnalyticsFilter';
} & { filterType?: 'PAGE_VIEW' };

export const PrivacyAnalyticsFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.analyticsfilter.PrivacyAnalyticsFilter';
export const PrivacyAnalyticsFilterDiscriminant = 'PRIVACY';
export const PrivacyAnalyticsFilterDiscriminantKey = 'filterType';
export type PrivacyAnalyticsFilter = {
  operator: ComHubspotInbounddbListsegFiltersAnalyticsfilterPrivacyAnalyticsFilterIF.SupportedOperator;
  privacyName: string;
  pruningRefineBy: Default<PruningRefineBy>;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  refineBy: Default<RefineBy>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.analyticsfilter.PrivacyAnalyticsFilter';
} & { filterType?: 'PRIVACY' };

export namespace ComHubspotInbounddbListsegFiltersAnalyticsfilterCtaAnalyticsFilterIF {
  export type SupportedOperator =
    | 'HAS_CLICKED_CTA'
    | 'HAS_NOT_CLICKED_CTA'
    | 'HAS_OPENED_CTA'
    | 'HAS_NOT_OPENED_CTA'
    | 'HAS_CLICKED_CTA_PLACEMENT'
    | 'HAS_NOT_CLICKED_CTA_PLACEMENT'
    | 'HAS_OPENED_CTA_PLACEMENT'
    | 'HAS_NOT_OPENED_CTA_PLACEMENT'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersAnalyticsfilterEventAnalyticsFilterIF {
  export type SupportedOperator =
    | 'HAS_EVENT'
    | 'NOT_HAS_EVENT'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersAnalyticsfilterPageViewAnalyticsFilterIF {
  export type SupportedOperator =
    | 'HAS_PAGEVIEW_EQ'
    | 'HAS_PAGEVIEW_CONTAINS'
    | 'HAS_PAGEVIEW_MATCHES_REGEX'
    | 'NOT_HAS_PAGEVIEW_EQ'
    | 'NOT_HAS_PAGEVIEW_CONTAINS'
    | 'NOT_HAS_PAGEVIEW_MATCHES_REGEX'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersAnalyticsfilterPrivacyAnalyticsFilterIF {
  export type SupportedOperator =
    | 'PRIVACY_CONSENT_GRANTED'
    | 'PRIVACY_CONSENT_NOT_GRANTED'
    | unhandledEnumCase;
}

export const NumAssociationsFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.association.NumAssociationsFilter';
export const NumAssociationsFilterDiscriminant = 'NUM_ASSOCIATIONS';
export const NumAssociationsFilterDiscriminantKey = 'filterType';
export type NumAssociationsFilter = {
  associationSpec: AssociationSpec;
  coalescingRefineBy: CoalescingRefineBy;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.association.NumAssociationsFilter';
} & { filterType?: 'NUM_ASSOCIATIONS' };

export const CampaignInfluencedFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.campaigninfluenced.CampaignInfluencedFilter';
export const CampaignInfluencedFilterDiscriminant = 'CAMPAIGN_INFLUENCED';
export const CampaignInfluencedFilterDiscriminantKey = 'filterType';
export type CampaignInfluencedFilter = {
  campaignId: string;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.campaigninfluenced.CampaignInfluencedFilter';
} & { filterType?: 'CAMPAIGN_INFLUENCED' };

export const CommunicationSubscriptionFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.communicationsubscriptionfilter.CommunicationSubscriptionFilter';
export const CommunicationSubscriptionFilterDiscriminant =
  'COMMUNICATION_SUBSCRIPTION';
export const CommunicationSubscriptionFilterDiscriminantKey = 'filterType';
export type CommunicationSubscriptionFilter = {
  channel: Channel;
  subscriptionIds: Default<number[]>;
  acceptedOptStates: Default<ComHubspotSubscriptionsCoreStatus.OptState[]>;
  businessUnitId?: number;
  subscriptionType: ComHubspotInbounddbListsegFiltersCommunicationsubscriptionfilterCommunicationSubscriptionFilterIF.SubscriptionType;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.communicationsubscriptionfilter.CommunicationSubscriptionFilter';
} & { filterType?: 'COMMUNICATION_SUBSCRIPTION' };

export namespace ComHubspotInbounddbListsegFiltersCommunicationsubscriptionfilterCommunicationSubscriptionFilterIF {
  export type SubscriptionType =
    | 'PORTAL_WIDE'
    | 'BUSINESS_UNIT_WIDE'
    | 'INDIVIDUAL_SUBSCRIPTION'
    | unhandledEnumCase;
}

export const ConstantFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.constant.ConstantFilter';
export const ConstantFilterDiscriminant = 'CONSTANT';
export const ConstantFilterDiscriminantKey = 'filterType';
export type ConstantFilter = {
  shouldAccept: boolean;
  source?: string;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.constant.ConstantFilter';
} & { filterType?: 'CONSTANT' };

export const DatasetFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.datasetfilter.DatasetFilter';
export const DatasetFilterDiscriminant = 'DATASET';
export const DatasetFilterDiscriminantKey = 'filterType';
export type DatasetFilter = {
  datasetId: number;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.datasetfilter.DatasetFilter';
} & { filterType?: 'DATASET' };

export const EmailEventFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.emaileventfilter.EmailEventFilter';
export const EmailEventFilterDiscriminant = 'EMAIL_EVENT';
export const EmailEventFilterDiscriminantKey = 'filterType';
export type EmailEventFilter = {
  level: EmailIdLevel;
  emailId: number;
  appId: number;
  emailFilterLines: Default<EmailEventFilterLine[]>;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.emaileventfilter.EmailEventFilter';
} & { filterType?: 'EMAIL_EVENT' };

export type EmailEventFilterLine = {
  negated: boolean;
  eventType?: EmailEventType;
  eventTypes: Default<EmailEventType[]>;
  countryCodes: Default<string[]>;
  deviceType?: DeviceType;
  clickUrlSubstring?: string;
  relativeEventDelta?: number;
  pruningRefineBy: Default<PruningRefineBy>;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  refineBy: Default<RefineBy>;
};

export type EmailIdLevel =
  | 'EMAIL_API_CAMPAIGN'
  | 'EMAIL_API_CAMPAIGN_GROUP'
  | 'HUBSPOT_CAMPAIGN'
  | unhandledEnumCase;

export type DeviceType =
  | 'COMPUTER'
  | 'MOBILE'
  | 'TABLET'
  | 'GAME_CONSOLE'
  | 'DIGITAL_MEDIA_RECEIVER'
  | 'UNKNOWN'
  | unhandledEnumCase;

export type EmailEventType =
  | 'SENT'
  | 'DROPPED'
  | 'DELIVERED'
  | 'DEFERRED'
  | 'BOUNCE'
  | 'OPEN'
  | 'CLICK'
  | 'PRINT'
  | 'FORWARD'
  | 'STATUSCHANGE'
  | 'SPAMREPORT'
  | 'UNSUBSCRIBED'
  | 'SUPPRESSED'
  | 'REPLIED'
  | unhandledEnumCase;

export const EmailSubscriptionFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.emailsubscriptionfilter.EmailSubscriptionFilter';
export const EmailSubscriptionFilterDiscriminant = 'EMAIL_SUBSCRIPTION';
export const EmailSubscriptionFilterDiscriminantKey = 'filterType';
export type EmailSubscriptionFilter = {
  subscriptionIds: Default<number[]>;
  acceptedStatuses: Default<EmailSubscriptionStatus[]>;
  subscriptionType: Default<ComHubspotInbounddbListsegFiltersEmailsubscriptionfilterEmailSubscriptionFilterIF.SubscriptionType>;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.emailsubscriptionfilter.EmailSubscriptionFilter';
} & { filterType?: 'EMAIL_SUBSCRIPTION' };

export type EmailSubscriptionStatus =
  | 'OPT_IN'
  | 'OPT_OUT'
  | 'NOT_OPTED'
  | unhandledEnumCase;

export namespace ComHubspotInbounddbListsegFiltersEmailsubscriptionfilterEmailSubscriptionFilterIF {
  export type SubscriptionType =
    | 'PORTAL'
    | 'BRAND'
    | 'SUBSCRIPTION'
    | 'HARDBOUNCE'
    | 'SPAMREPORT'
    | unhandledEnumCase;
}

export const FormSubmissionFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.formsfilter.FormSubmissionFilter';
export const FormSubmissionFilterDiscriminant = 'FORM_SUBMISSION';
export const FormSubmissionFilterDiscriminantKey = 'filterType';
export type FormSubmissionFilter = {
  pruningRefineBy?: PruningRefineBy;
  coalescingRefineBy?: CoalescingRefineBy;
  formId?: string;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.formsfilter.FormSubmissionFilter';
} & { filterType?: 'FORM_SUBMISSION' };

export const FormSubmissionOnPageFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.formsfilter.FormSubmissionOnPageFilter';
export const FormSubmissionOnPageFilterDiscriminant = 'FORM_SUBMISSION_ON_PAGE';
export const FormSubmissionOnPageFilterDiscriminantKey = 'filterType';
export type FormSubmissionOnPageFilter = {
  pageId: string;
  pruningRefineBy?: PruningRefineBy;
  coalescingRefineBy?: CoalescingRefineBy;
  formId?: string;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.formsfilter.FormSubmissionOnPageFilter';
} & { filterType?: 'FORM_SUBMISSION_ON_PAGE' };

export const InListFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.inlist.InListFilter';
export const InListFilterDiscriminant = 'IN_LIST';
export const InListFilterDiscriminantKey = 'filterType';
export type InListFilter = {
  listId?: number;
  listIdMaybe: Default<number>;
  operator: ComHubspotInbounddbListsegFiltersInlistInListFilterIF.SupportedOperator;
  metadata?: InListFilterMetadata;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.inlist.InListFilter';
} & { filterType?: 'IN_LIST' };

export type InListFilterMetadata = { inListType: InListType; id: string };

export namespace ComHubspotInbounddbListsegFiltersInlistInListFilterIF {
  export type SupportedOperator = 'IN_LIST' | 'NOT_IN_LIST' | unhandledEnumCase;
}

export type InListType =
  | 'WORKFLOWS_ENROLLMENT'
  | 'WORKFLOWS_ACTIVE'
  | 'WORKFLOWS_GOAL'
  | 'WORKFLOWS_COMPLETED'
  | 'IMPORT'
  | 'DATASET'
  | 'DATASETS'
  | 'MARKET'
  | unhandledEnumCase;

export const IntegrationEventFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.integrationsfilter.IntegrationEventFilter';
export const IntegrationEventFilterDiscriminant = 'INTEGRATION_EVENT';
export const IntegrationEventFilterDiscriminantKey = 'filterType';
export type IntegrationEventFilter = {
  eventTypeId: number;
  filterLines: Default<IntegrationFilterLine[]>;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.integrationsfilter.IntegrationEventFilter';
} & { filterType?: 'INTEGRATION_EVENT' };

export type IntegrationFilterLine = {
  property: string;
  operation: PropertyFilterOperation;
};

export const MultiInListFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.multiinlist.MultiInListFilter';
export const MultiInListFilterDiscriminant = 'MULTI_IN_LIST';
export const MultiInListFilterDiscriminantKey = 'filterType';
export type MultiInListFilter = {
  listIds: Default<number[]>;
  operator: ComHubspotInbounddbListsegFiltersMultiinlistMultiInListFilterIF.SupportedOperator;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.multiinlist.MultiInListFilter';
} & { filterType?: 'MULTI_IN_LIST' };

export namespace ComHubspotInbounddbListsegFiltersMultiinlistMultiInListFilterIF {
  export type SupportedOperator =
    | 'IN_ANY_LIST'
    | 'NOT_IN_ANY_LIST'
    | 'IN_ALL_LISTS'
    | 'NOT_IN_ALL_LISTS'
    | unhandledEnumCase;
}

export const AllPropertyTypesOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.AllPropertyTypesOperation';
export const AllPropertyTypesOperationDiscriminant = 'alltypes';
export const AllPropertyTypesOperationDiscriminantKey = 'propertyType';
export type AllPropertyTypesOperation = {
  pruningRefineBy?: PruningRefineBy;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterAllPropertyTypesOperationIF.SupportedOperator;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.AllPropertyTypesOperation';
} & { propertyType?: 'alltypes' };

export const BoolPropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.BoolPropertyOperation';
export const BoolPropertyOperationDiscriminant = 'bool';
export const BoolPropertyOperationDiscriminantKey = 'propertyType';
export type BoolPropertyOperation = {
  value: boolean;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterBoolPropertyOperationIF.SupportedOperator;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.BoolPropertyOperation';
} & { propertyType?: 'bool' };

export const CalendarDatePropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.CalendarDatePropertyOperation';
export const CalendarDatePropertyOperationDiscriminant = 'calendar-date';
export const CalendarDatePropertyOperationDiscriminantKey = 'propertyType';
export type CalendarDatePropertyOperation = {
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterCalendarDatePropertyOperationIF.SupportedOperator;
  timeUnit: CalendarTimeUnit;
  fiscalYearStart?: JavaTime.Month;
  useFiscalYear: Default<boolean>;
  timeUnitCount: Default<number>;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.CalendarDatePropertyOperation';
} & { propertyType?: 'calendar-date' };

export const ComparativeDatePropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.ComparativeDatePropertyOperation';
export const ComparativeDatePropertyOperationDiscriminant =
  'datetime-comparative';
export const ComparativeDatePropertyOperationDiscriminantKey = 'propertyType';
export type ComparativeDatePropertyOperation = {
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterComparativePropertyOperationBase.SupportedOperator;
  comparisonPropertyName: string;
  defaultComparisonValue?: string;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.ComparativeDatePropertyOperation';
} & { propertyType?: 'datetime-comparative' };

export const ComparativePropertyUpdatedOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.ComparativePropertyUpdatedOperation';
export const ComparativePropertyUpdatedOperationDiscriminant =
  'property-updated-comparative';
export const ComparativePropertyUpdatedOperationDiscriminantKey =
  'propertyType';
export type ComparativePropertyUpdatedOperation = {
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterComparativePropertyOperationBase.SupportedOperator;
  comparisonPropertyName: string;
  defaultComparisonValue?: string;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.ComparativePropertyUpdatedOperation';
} & { propertyType?: 'property-updated-comparative' };

export const DatePropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.DatePropertyOperation';
export const DatePropertyOperationDiscriminant = 'date';
export const DatePropertyOperationDiscriminantKey = 'propertyType';
export type DatePropertyOperation = {
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterDatePropertyOperationIF.SupportedOperator;
  year: number;
  month: ComHubspotInbounddbListsegFiltersPropertyfilterDatePropertyOperationIF.Month;
  day: number;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.DatePropertyOperation';
} & { propertyType?: 'date' };

export const DateTimePropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.DateTimePropertyOperation';
export const DateTimePropertyOperationDiscriminant = 'datetime';
export const DateTimePropertyOperationDiscriminantKey = 'propertyType';
export type DateTimePropertyOperation = {
  timestamp: number;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterDateTimePropertyOperationIF.SupportedOperator;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  requiresTimeZoneConversion: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.DateTimePropertyOperation';
} & { propertyType?: 'datetime' };

export const EnumerationPropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.EnumerationPropertyOperation';
export const EnumerationPropertyOperationDiscriminant = 'enumeration';
export const EnumerationPropertyOperationDiscriminantKey = 'propertyType';
export type EnumerationPropertyOperation = {
  values: Default<string[]>;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterEnumerationPropertyOperationIF.SupportedOperator;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.EnumerationPropertyOperation';
} & { propertyType?: 'enumeration' };

export const MultiStringPropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.MultiStringPropertyOperation';
export const MultiStringPropertyOperationDiscriminant = 'multistring';
export const MultiStringPropertyOperationDiscriminantKey = 'propertyType';
export type MultiStringPropertyOperation = {
  values: Default<string[]>;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterMultiStringPropertyOperationIF.SupportedOperator;
  pruningRefineBy?: PruningRefineBy;
  coalescingRefineBy: Default<CoalescingRefineBy>;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.MultiStringPropertyOperation';
} & { propertyType?: 'multistring' };

export const NumberPropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.NumberPropertyOperation';
export const NumberPropertyOperationDiscriminant = 'number';
export const NumberPropertyOperationDiscriminantKey = 'propertyType';
export type NumberPropertyOperation = {
  value: number;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterNumberPropertyOperationIF.SupportedOperator;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.NumberPropertyOperation';
} & { propertyType?: 'number' };

export const RangedDatePropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.RangedDatePropertyOperation';
export const RangedDatePropertyOperationDiscriminant = 'datetime-ranged';
export const RangedDatePropertyOperationDiscriminantKey = 'propertyType';
export type RangedDatePropertyOperation = {
  lowerBoundTimestamp: number;
  upperBoundTimestamp: number;
  requiresTimeZoneConversion: Default<boolean>;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterRangedDatePropertyOperationBase.SupportedOperator;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.RangedDatePropertyOperation';
} & { propertyType?: 'datetime-ranged' };

export const RangedNumberPropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.RangedNumberPropertyOperation';
export const RangedNumberPropertyOperationDiscriminant = 'number-ranged';
export const RangedNumberPropertyOperationDiscriminantKey = 'propertyType';
export type RangedNumberPropertyOperation = {
  lowerBound: number;
  upperBound: number;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterRangedNumericPropertyOperationBase.SupportedOperator;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.RangedNumberPropertyOperation';
} & { propertyType?: 'number-ranged' };

export const RegexPropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.RegexPropertyOperation';
export const RegexPropertyOperationDiscriminant = 'regex';
export const RegexPropertyOperationDiscriminantKey = 'propertyType';
export type RegexPropertyOperation = {
  pattern: string;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterRegexPropertyOperationIF.SupportedOperator;
  caseSensitive: Default<boolean>;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.RegexPropertyOperation';
} & { propertyType?: 'regex' };

export const RollingDateRangePropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.RollingDateRangePropertyOperation';
export const RollingDateRangePropertyOperationDiscriminant = 'datetime-rolling';
export const RollingDateRangePropertyOperationDiscriminantKey = 'propertyType';
export type RollingDateRangePropertyOperation = {
  numberOfDays: number;
  operator: RollingDateRangeOperator;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  requiresTimeZoneConversion: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.RollingDateRangePropertyOperation';
} & { propertyType?: 'datetime-rolling' };

export const RollingPropertyUpdatedOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.RollingPropertyUpdatedOperation';
export const RollingPropertyUpdatedOperationDiscriminant =
  'rolling-property-updated';
export const RollingPropertyUpdatedOperationDiscriminantKey = 'propertyType';
export type RollingPropertyUpdatedOperation = {
  numberOfDays: number;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterRollingPropertyUpdatedOperationIF.SupportedOperator;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.RollingPropertyUpdatedOperation';
} & { propertyType?: 'rolling-property-updated' };

export const StringPropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.StringPropertyOperation';
export const StringPropertyOperationDiscriminant = 'string';
export const StringPropertyOperationDiscriminantKey = 'propertyType';
export type StringPropertyOperation = {
  value: string;
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterStringPropertyOperationIF.SupportedOperator;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.StringPropertyOperation';
} & { propertyType?: 'string' };

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterAllPropertyTypesOperationIF {
  export type SupportedOperator =
    | 'IS_KNOWN'
    | 'IS_UNKNOWN'
    | 'IS_BLANK'
    | 'IS_NOT_BLANK'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterBoolPropertyOperationIF {
  export type SupportedOperator =
    | 'IS_EQUAL_TO'
    | 'IS_NOT_EQUAL_TO'
    | 'HAS_EVER_BEEN_EQUAL_TO'
    | 'HAS_NEVER_BEEN_EQUAL_TO'
    | unhandledEnumCase;
}

export type CalendarTimeUnit =
  | 'DAY'
  | 'WEEK'
  | 'MONTH'
  | 'QUARTER'
  | 'YEAR'
  | unhandledEnumCase;

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterCalendarDatePropertyOperationIF {
  export type SupportedOperator =
    | 'IN_THIS_TIME_UNIT'
    | 'IN_THIS_TIME_UNIT_SO_FAR'
    | 'IN_NEXT_TIME_UNIT'
    | 'IN_LAST_TIME_UNIT'
    | 'IN_LAST_TIME_UNIT_SO_FAR'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterComparativePropertyOperationBase {
  export type SupportedOperator = 'IS_BEFORE' | 'IS_AFTER' | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterDatePropertyOperationIF {
  export type Month =
    | 'JAN'
    | 'FEB'
    | 'MAR'
    | 'APR'
    | 'MAY'
    | 'JUN'
    | 'JUL'
    | 'AUG'
    | 'SEP'
    | 'OCT'
    | 'NOV'
    | 'DEC'
    | unhandledEnumCase;

  export type SupportedOperator =
    | 'EQUAL'
    | 'BEFORE'
    | 'AFTER'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterDateTimePropertyOperationIF {
  export type SupportedOperator =
    | 'IS_BEFORE'
    | 'IS_AFTER'
    | 'IS_EQUAL_TO'
    | 'IS_BEFORE_DATE'
    | 'IS_AFTER_DATE'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterEnumerationPropertyOperationIF {
  export type SupportedOperator =
    | 'IS_ANY_OF'
    | 'IS_NONE_OF'
    | 'IS_EXACTLY'
    | 'IS_NOT_EXACTLY'
    | 'CONTAINS_ALL'
    | 'DOES_NOT_CONTAIN_ALL'
    | 'HAS_EVER_BEEN_ANY_OF'
    | 'HAS_NEVER_BEEN_ANY_OF'
    | 'HAS_EVER_BEEN_EXACTLY'
    | 'HAS_NEVER_BEEN_EXACTLY'
    | 'HAS_EVER_CONTAINED_ALL'
    | 'HAS_NEVER_CONTAINED_ALL'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterMultiStringPropertyOperationIF {
  export type SupportedOperator =
    | 'IS_EQUAL_TO'
    | 'IS_NOT_EQUAL_TO'
    | 'CONTAINS'
    | 'CONTAINS_EXACTLY'
    | 'DOES_NOT_CONTAIN'
    | 'DOES_NOT_CONTAIN_EXACTLY'
    | 'STARTS_WITH'
    | 'ENDS_WITH'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterNumberPropertyOperationIF {
  export type SupportedOperator =
    | 'IS_EQUAL_TO'
    | 'IS_NOT_EQUAL_TO'
    | 'IS_GREATER_THAN'
    | 'IS_GREATER_THAN_OR_EQUAL_TO'
    | 'IS_LESS_THAN'
    | 'IS_LESS_THAN_OR_EQUAL_TO'
    | 'HAS_EVER_BEEN_EQUAL_TO'
    | 'HAS_NEVER_BEEN_EQUAL_TO'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterRangedDatePropertyOperationBase {
  export type SupportedOperator =
    | 'IS_BETWEEN'
    | 'IS_NOT_BETWEEN'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterRangedNumericPropertyOperationBase {
  export type SupportedOperator =
    | 'IS_BETWEEN'
    | 'IS_NOT_BETWEEN'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterRegexPropertyOperationIF {
  export type SupportedOperator =
    | 'MATCHES_REGEX'
    | 'DOES_NOT_MATCH_REGEX'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterRollingPropertyUpdatedOperationIF {
  export type SupportedOperator =
    | 'UPDATED_IN_LAST_X_DAYS'
    | 'NOT_UPDATED_IN_LAST_X_DAYS'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterStringPropertyOperationIF {
  export type SupportedOperator =
    | 'IS_EQUAL_TO'
    | 'IS_NOT_EQUAL_TO'
    | 'CONTAINS'
    | 'DOES_NOT_CONTAIN'
    | 'STARTS_WITH'
    | 'ENDS_WITH'
    | 'HAS_EVER_BEEN_EQUAL_TO'
    | 'HAS_NEVER_BEEN_EQUAL_TO'
    | 'HAS_EVER_CONTAINED'
    | 'HAS_NEVER_CONTAINED'
    | unhandledEnumCase;
}

export const ComparativeBoolPropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.comparativeproperty.ComparativeBoolPropertyOperation';
export const ComparativeBoolPropertyOperationDiscriminant = 'bool-comparative';
export const ComparativeBoolPropertyOperationDiscriminantKey = 'propertyType';
export type ComparativeBoolPropertyOperation = {
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterComparativepropertyComparativeBoolPropertyOperationIF.SupportedOperator;
  comparisonPropertyName: string;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.comparativeproperty.ComparativeBoolPropertyOperation';
} & { propertyType?: 'bool-comparative' };

export const ComparativeNumberPropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.comparativeproperty.ComparativeNumberPropertyOperation';
export const ComparativeNumberPropertyOperationDiscriminant =
  'number-comparative';
export const ComparativeNumberPropertyOperationDiscriminantKey = 'propertyType';
export type ComparativeNumberPropertyOperation = {
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterComparativepropertyComparativeNumberPropertyOperationIF.SupportedOperator;
  comparisonPropertyName: string;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.comparativeproperty.ComparativeNumberPropertyOperation';
} & { propertyType?: 'number-comparative' };

export const ComparativeStringPropertyOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.propertyfilter.comparativeproperty.ComparativeStringPropertyOperation';
export const ComparativeStringPropertyOperationDiscriminant =
  'string-comparative';
export const ComparativeStringPropertyOperationDiscriminantKey = 'propertyType';
export type ComparativeStringPropertyOperation = {
  operator: ComHubspotInbounddbListsegFiltersPropertyfilterComparativepropertyComparativeStringPropertyOperationIF.SupportedOperator;
  comparisonPropertyName: string;
  /** @deprecated */
  defaultValue?: string;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.propertyfilter.comparativeproperty.ComparativeStringPropertyOperation';
} & { propertyType?: 'string-comparative' };

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterComparativepropertyComparativeBoolPropertyOperationIF {
  export type SupportedOperator =
    | 'IS_EQUAL_TO'
    | 'IS_NOT_EQUAL_TO'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterComparativepropertyComparativeNumberPropertyOperationIF {
  export type SupportedOperator =
    | 'IS_EQUAL_TO'
    | 'IS_NOT_EQUAL_TO'
    | 'IS_GREATER_THAN'
    | 'IS_GREATER_THAN_OR_EQUAL_TO'
    | 'IS_LESS_THAN'
    | 'IS_LESS_THAN_OR_EQUAL_TO'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersPropertyfilterComparativepropertyComparativeStringPropertyOperationIF {
  export type SupportedOperator =
    | 'IS_EQUAL_TO'
    | 'IS_NOT_EQUAL_TO'
    | 'CONTAINS'
    | 'DOES_NOT_CONTAIN'
    | 'STARTS_WITH'
    | 'ENDS_WITH'
    | unhandledEnumCase;
}

export const AbsoluteComparativeTimestampRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.AbsoluteComparativeTimestampRefineBy';
export const AbsoluteComparativeTimestampRefineByDiscriminant =
  'AbsoluteComparativeTimestampRefineBy';
export const AbsoluteComparativeTimestampRefineByDiscriminantKey = 'type';
export type AbsoluteComparativeTimestampRefineBy = {
  timestamp: number;
  comparison: ComHubspotInbounddbListsegFiltersRefinebysAbsoluteComparativeTimestampRefineByIF.Comparison;
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.AbsoluteComparativeTimestampRefineBy';
} & { type?: 'AbsoluteComparativeTimestampRefineBy' };

export const AbsoluteRangedTimestampRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.AbsoluteRangedTimestampRefineBy';
export const AbsoluteRangedTimestampRefineByDiscriminant =
  'AbsoluteRangedTimestampRefineBy';
export const AbsoluteRangedTimestampRefineByDiscriminantKey = 'type';
export type AbsoluteRangedTimestampRefineBy = {
  lowerTimestamp: number;
  upperTimestamp: number;
  rangeType: ComHubspotInbounddbListsegFiltersRefinebysAbsoluteRangedTimestampRefineByIF.RangeType;
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.AbsoluteRangedTimestampRefineBy';
} & { type?: 'AbsoluteRangedTimestampRefineBy' };

export const AllHistoryRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.AllHistoryRefineBy';
export const AllHistoryRefineByDiscriminant = 'AllHistoryRefineBy';
export const AllHistoryRefineByDiscriminantKey = 'type';
export type AllHistoryRefineBy = {
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.AllHistoryRefineBy';
} & { type?: 'AllHistoryRefineBy' };

export const BetweenRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.BetweenRefineBy';
export const BetweenRefineByDiscriminant = 'between-refine';
export const BetweenRefineByDiscriminantKey = 'refineByType';
export type BetweenRefineBy = {
  lowerBoundTimestamp: number;
  upperBoundTimestamp: number;
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.BetweenRefineBy';
} & { refineByType?: 'between-refine' };

export const CoalescingRefineByDiscriminantKey = 'type';
export type CoalescingRefineBy =
  | NumOccurrencesRefineBy
  | SetOccurrencesRefineBy;

export const NumOccurrencesRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.NumOccurrencesRefineBy';
export const NumOccurrencesRefineByDiscriminant = 'NumOccurrencesRefineBy';
export const NumOccurrencesRefineByDiscriminantKey = 'type';
export type NumOccurrencesRefineBy = {
  minOccurrences?: number;
  maxOccurrences?: number;
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.NumOccurrencesRefineBy';
} & { type?: 'NumOccurrencesRefineBy' };

export const OccurrencesRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.OccurrencesRefineBy';
export const OccurrencesRefineByDiscriminant = 'occurrence-refine';
export const OccurrencesRefineByDiscriminantKey = 'refineByType';
export type OccurrencesRefineBy = {
  occurrences: number;
  operator: OccurrenceOperator;
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.OccurrencesRefineBy';
} & { refineByType?: 'occurrence-refine' };

export const PassThroughRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.PassThroughRefineBy';
export const PassThroughRefineByDiscriminant = 'passthrough-refine';
export const PassThroughRefineByDiscriminantKey = 'refineByType';
export type PassThroughRefineBy = {
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.PassThroughRefineBy';
} & { refineByType?: 'passthrough-refine' };

export const PruningRefineByDiscriminantKey = 'type';
export type PruningRefineBy =
  | RelativeComparativeTimestampRefineBy
  | RelativeRangedTimestampRefineBy
  | AbsoluteComparativeTimestampRefineBy
  | AbsoluteRangedTimestampRefineBy
  | AllHistoryRefineBy
  | TimePointOperation
  | RangedTimeOperation;

export const RefineByDiscriminantKey = 'refineByType';
export type RefineBy =
  | OccurrencesRefineBy
  | TimestampRefineBy
  | BetweenRefineBy
  | PassThroughRefineBy
  | WithinRefineBy;

export const RelativeComparativeTimestampRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.RelativeComparativeTimestampRefineBy';
export const RelativeComparativeTimestampRefineByDiscriminant =
  'RelativeComparativeTimestampRefineBy';
export const RelativeComparativeTimestampRefineByDiscriminantKey = 'type';
export type RelativeComparativeTimestampRefineBy = {
  timeOffset: TimeOffset;
  comparison: ComHubspotInbounddbListsegFiltersRefinebysRelativeComparativeTimestampRefineByIF.Comparison;
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.RelativeComparativeTimestampRefineBy';
} & { type?: 'RelativeComparativeTimestampRefineBy' };

export const RelativeRangedTimestampRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.RelativeRangedTimestampRefineBy';
export const RelativeRangedTimestampRefineByDiscriminant =
  'RelativeRangedTimestampRefineBy';
export const RelativeRangedTimestampRefineByDiscriminantKey = 'type';
export type RelativeRangedTimestampRefineBy = {
  lowerBoundOffset: TimeOffset;
  upperBoundOffset: TimeOffset;
  rangeType: ComHubspotInbounddbListsegFiltersRefinebysRelativeRangedTimestampRefineByIF.RangeType;
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.RelativeRangedTimestampRefineBy';
} & { type?: 'RelativeRangedTimestampRefineBy' };

export const SetOccurrencesRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.SetOccurrencesRefineBy';
export const SetOccurrencesRefineByDiscriminant = 'SetOccurrencesRefineBy';
export const SetOccurrencesRefineByDiscriminantKey = 'type';
export type SetOccurrencesRefineBy = {
  setType: SetType;
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.SetOccurrencesRefineBy';
} & { type?: 'SetOccurrencesRefineBy' };

export type TimeOffset = {
  offsetDirection: OffsetDirection;
  timeUnit: ComHubspotInbounddbListsegFiltersRefinebys.TimeUnit;
  amount: number;
};

export const TimestampRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.TimestampRefineBy';
export const TimestampRefineByDiscriminant = 'timestamp-refine';
export const TimestampRefineByDiscriminantKey = 'refineByType';
export type TimestampRefineBy = {
  timestamp: number;
  operator: TimestampOperator;
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.TimestampRefineBy';
} & { refineByType?: 'timestamp-refine' };

export const WithinRefineByTypename =
  'com.hubspot.inbounddb.listseg.filters.refinebys.WithinRefineBy';
export const WithinRefineByDiscriminant = 'within-refine';
export const WithinRefineByDiscriminantKey = 'refineByType';
export type WithinRefineBy = {
  within: number;
  timeUnit: ComHubspotInbounddbListsegFiltersRefinebysWithinRefineByIF.TimeUnit;
  timeWindow: TimeWindow;
  __typename: 'com.hubspot.inbounddb.listseg.filters.refinebys.WithinRefineBy';
} & { refineByType?: 'within-refine' };

export namespace ComHubspotInbounddbListsegFiltersRefinebys {
  export type TimeUnit =
    | 'WEEKS'
    | 'DAYS'
    | 'HOURS'
    | 'MINUTES'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersRefinebysAbsoluteComparativeTimestampRefineByIF {
  export type Comparison = 'BEFORE' | 'AFTER' | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersRefinebysAbsoluteRangedTimestampRefineByIF {
  export type RangeType = 'BETWEEN' | 'NOT_BETWEEN' | unhandledEnumCase;
}

export type OccurrenceOperator = 'MAX' | 'MIN' | 'EQ' | unhandledEnumCase;

export namespace ComHubspotInbounddbListsegFiltersRefinebysRelativeComparativeTimestampRefineByIF {
  export type Comparison = 'BEFORE' | 'AFTER' | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersRefinebysRelativeRangedTimestampRefineByIF {
  export type RangeType = 'BETWEEN' | 'NOT_BETWEEN' | unhandledEnumCase;
}

export type SetType =
  | 'ALL'
  | 'ALL_INCLUDE_EMPTY'
  | 'ANY'
  | 'NONE'
  | 'NONE_EXCLUDE_EMPTY'
  | 'ANY_INCLUDE_EMPTY'
  | unhandledEnumCase;

export type OffsetDirection = 'PAST' | 'FUTURE' | unhandledEnumCase;

export type TimestampOperator = 'IS_AFTER' | 'IS_BEFORE' | unhandledEnumCase;

export type TimeWindow = 'INCLUSIVE' | 'EXCLUSIVE' | unhandledEnumCase;

export namespace ComHubspotInbounddbListsegFiltersRefinebysWithinRefineByIF {
  export type TimeUnit = 'WEEKS' | 'DAYS' | unhandledEnumCase;
}

export const SurveyMonkeyFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.surveymonkeyfilter.SurveyMonkeyFilter';
export const SurveyMonkeyFilterDiscriminant = 'SURVEY_MONKEY';
export const SurveyMonkeyFilterDiscriminantKey = 'filterType';
export type SurveyMonkeyFilter = {
  operator: ComHubspotInbounddbListsegFiltersSurveymonkeyfilterSurveyMonkeyFilterIF.SupportedOperator;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  surveyId: string;
  __typename: 'com.hubspot.inbounddb.listseg.filters.surveymonkeyfilter.SurveyMonkeyFilter';
} & { filterType?: 'SURVEY_MONKEY' };

export const SurveyMonkeyValueFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.surveymonkeyfilter.SurveyMonkeyValueFilter';
export const SurveyMonkeyValueFilterDiscriminant = 'SURVEY_MONKEY_VALUE';
export const SurveyMonkeyValueFilterDiscriminantKey = 'filterType';
export type SurveyMonkeyValueFilter = {
  surveyQuestion: string;
  operator: ComHubspotInbounddbListsegFiltersSurveymonkeyfilterSurveyMonkeyValueFilterIF.SupportedOperator;
  valueComparison: PropertyFilterOperation;
  surveyAnswerRowId?: string;
  surveyAnswerColId?: string;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  surveyId: string;
  __typename: 'com.hubspot.inbounddb.listseg.filters.surveymonkeyfilter.SurveyMonkeyValueFilter';
} & { filterType?: 'SURVEY_MONKEY_VALUE' };

export namespace ComHubspotInbounddbListsegFiltersSurveymonkeyfilterSurveyMonkeyFilterIF {
  export type SupportedOperator =
    | 'HAS_RESPONDED_TO_SURVEY'
    | 'HAS_NOT_RESPONDED_TO_SURVEY'
    | unhandledEnumCase;
}

export namespace ComHubspotInbounddbListsegFiltersSurveymonkeyfilterSurveyMonkeyValueFilterIF {
  export type SupportedOperator =
    | 'HAS_ANSWERED_SURVEY_QUESTION_WITH_VALUE'
    | unhandledEnumCase;
}

export const DatePointTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.DatePoint';
export const DatePointDiscriminant = 'DATE';
export const DatePointDiscriminantKey = 'timeType';
export type DatePoint = {
  year: number;
  month: number;
  day: number;
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
  timezoneSource: Default<TimezoneSource>;
  zoneId: string;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.DatePoint';
} & { timeType?: 'DATE' };

export const FiscalQuarterTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.FiscalQuarter';
export const FiscalQuarterDiscriminant = 'FISCAL_QUARTER';
export const FiscalQuarterDiscriminantKey = 'referenceType';
export type FiscalQuarter = {
  month: number;
  day: number;
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.FiscalQuarter';
} & { referenceType?: 'FISCAL_QUARTER' };

export const FiscalYearTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.FiscalYear';
export const FiscalYearDiscriminant = 'FISCAL_YEAR';
export const FiscalYearDiscriminantKey = 'referenceType';
export type FiscalYear = {
  month: number;
  day: number;
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.FiscalYear';
} & { referenceType?: 'FISCAL_YEAR' };

export type IndexOffset = {
  years?: number;
  quarters?: number;
  months?: number;
  weeks?: number;
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
  milliseconds?: number;
};

export const IndexReferenceDiscriminantKey = 'referenceType';
export type IndexReference =
  | NowReference
  | TodayReference
  | WeekReference
  | MonthReference
  | QuarterReference
  | FiscalQuarter
  | YearReference
  | FiscalYear;

export const IndexedTimePointTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.IndexedTimePoint';
export const IndexedTimePointDiscriminant = 'INDEXED';
export const IndexedTimePointDiscriminantKey = 'timeType';
export type IndexedTimePoint = {
  indexReference: IndexReference;
  offset?: IndexOffset;
  shouldGenerateRefreshTime?: boolean;
  timezoneSource: Default<TimezoneSource>;
  zoneId: string;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.IndexedTimePoint';
} & { timeType?: 'INDEXED' };

export const MonthReferenceTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.MonthReference';
export const MonthReferenceDiscriminant = 'MONTH';
export const MonthReferenceDiscriminantKey = 'referenceType';
export type MonthReference = {
  day: number;
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.MonthReference';
} & { referenceType?: 'MONTH' };

export const NowReferenceTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.NowReference';
export const NowReferenceDiscriminant = 'NOW';
export const NowReferenceDiscriminantKey = 'referenceType';
export type NowReference = {
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.NowReference';
} & { referenceType?: 'NOW' };

export const PropertyReferencedTimeTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.PropertyReferencedTime';
export const PropertyReferencedTimeDiscriminant = 'PROPERTY_REFERENCED';
export const PropertyReferencedTimeDiscriminantKey = 'timeType';
export type PropertyReferencedTime = {
  property: string;
  referenceType: ReferenceType;
  timezoneSource: Default<TimezoneSource>;
  zoneId: string;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.PropertyReferencedTime';
} & { timeType?: 'PROPERTY_REFERENCED' };

export const QuarterReferenceTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.QuarterReference';
export const QuarterReferenceDiscriminant = 'QUARTER';
export const QuarterReferenceDiscriminantKey = 'referenceType';
export type QuarterReference = {
  month: number;
  day: number;
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.QuarterReference';
} & { referenceType?: 'QUARTER' };

export const RangedTimeOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.RangedTimeOperation';
export const RangedTimeOperationDiscriminant = 'rangedtime';
export const RangedTimeOperationDiscriminantKey = 'type';
export type RangedTimeOperation = {
  operator: ComHubspotInbounddbListsegFiltersTimepointRangedTimeOperationIF.SupportedOperator;
  lowerBoundTimePoint: TimePoint;
  upperBoundTimePoint: TimePoint;
  lowerBoundEndpointBehavior: Default<EndpointInclusiveness>;
  upperBoundEndpointBehavior: Default<EndpointInclusiveness>;
  propertyParser: Default<ReferenceType>;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.RangedTimeOperation';
} & { propertyType?: 'rangedtime'; type?: 'rangedtime' };

export const TimePointDiscriminantKey = 'timeType';
export type TimePoint = DatePoint | IndexedTimePoint | PropertyReferencedTime;

export const TimePointOperationTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.TimePointOperation';
export const TimePointOperationDiscriminant = 'timepoint';
export const TimePointOperationDiscriminantKey = 'type';
export type TimePointOperation = {
  operator: ComHubspotInbounddbListsegFiltersTimepointTimePointOperationIF.SupportedOperator;
  timePoint: TimePoint;
  endpointBehavior: Default<EndpointInclusiveness>;
  propertyParser: Default<ReferenceType>;
  renderSpec?: string;
  propertyAspect?: PropertyAspect;
  includeObjectsWithNoValueSet: Default<boolean>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.TimePointOperation';
} & { propertyType?: 'timepoint'; type?: 'timepoint' };

export const TodayReferenceTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.TodayReference';
export const TodayReferenceDiscriminant = 'TODAY';
export const TodayReferenceDiscriminantKey = 'referenceType';
export type TodayReference = {
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.TodayReference';
} & { referenceType?: 'TODAY' };

export const WeekReferenceTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.WeekReference';
export const WeekReferenceDiscriminant = 'WEEK';
export const WeekReferenceDiscriminantKey = 'referenceType';
export type WeekReference = {
  dayOfWeek: DayOfWeek;
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.WeekReference';
} & { referenceType?: 'WEEK' };

export const YearReferenceTypename =
  'com.hubspot.inbounddb.listseg.filters.timepoint.YearReference';
export const YearReferenceDiscriminant = 'YEAR';
export const YearReferenceDiscriminantKey = 'referenceType';
export type YearReference = {
  month: number;
  day: number;
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
  __typename: 'com.hubspot.inbounddb.listseg.filters.timepoint.YearReference';
} & { referenceType?: 'YEAR' };

export type ReferenceType =
  | 'VALUE'
  | 'UPDATED_AT'
  | 'ANNIVERSARY'
  | 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION'
  | 'ANNIVERSARY_WITH_ZONE_SAME_LOCAL_CONVERSION'
  | unhandledEnumCase;

export namespace ComHubspotInbounddbListsegFiltersTimepointRangedTimeOperationIF {
  export type SupportedOperator =
    | 'IS_BETWEEN'
    | 'IS_NOT_BETWEEN'
    | unhandledEnumCase;
}

export type TimezoneSource = 'CUSTOM' | 'USER' | 'PORTAL' | unhandledEnumCase;

export type EndpointInclusiveness =
  | 'INCLUSIVE'
  | 'EXCLUSIVE'
  | unhandledEnumCase;

export namespace ComHubspotInbounddbListsegFiltersTimepointTimePointOperationIF {
  export type SupportedOperator = 'IS_BEFORE' | 'IS_AFTER' | unhandledEnumCase;
}

export const UnifiedEventsFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.unifiedevents.UnifiedEventsFilter';
export const UnifiedEventsFilterDiscriminant = 'UNIFIED_EVENTS';
export const UnifiedEventsFilterDiscriminantKey = 'filterType';
export type UnifiedEventsFilter = {
  eventTypeId?: string;
  filterLines: Default<UnifiedEventsFilterLine[]>;
  pruningRefineBy?: PruningRefineBy;
  coalescingRefineBy?: CoalescingRefineBy;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.unifiedevents.UnifiedEventsFilter';
} & { filterType?: 'UNIFIED_EVENTS' };

export type UnifiedEventsFilterLine = {
  property: string;
  operation: PropertyFilterOperation;
};

export const UnifiedEventsInListFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.unifiedevents.UnifiedEventsInListFilter';
export const UnifiedEventsInListFilterDiscriminant = 'UNIFIED_EVENTS_IN_LIST';
export const UnifiedEventsInListFilterDiscriminantKey = 'filterType';
export type UnifiedEventsInListFilter = {
  listId: number;
  eventTypeId: string;
  coalescingRefineBy?: CoalescingRefineBy;
  pruningRefineBy?: PruningRefineBy;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.unifiedevents.UnifiedEventsInListFilter';
} & { filterType?: 'UNIFIED_EVENTS_IN_LIST' };

export const WebinarFilterTypename =
  'com.hubspot.inbounddb.listseg.filters.webinarfilter.WebinarFilter';
export const WebinarFilterDiscriminant = 'WEBINAR';
export const WebinarFilterDiscriminantKey = 'filterType';
export type WebinarFilter = {
  operator: ComHubspotInbounddbListsegFiltersWebinarfilterWebinarFilterIF.SupportedOperator;
  webinarId?: string;
  frameworkFilterId?: number;
  filterInsightsId: Default<number>;
  __typename: 'com.hubspot.inbounddb.listseg.filters.webinarfilter.WebinarFilter';
} & { filterType?: 'WEBINAR' };

export namespace ComHubspotInbounddbListsegFiltersWebinarfilterWebinarFilterIF {
  export type SupportedOperator =
    | 'HAS_WEBINAR_REGISTRATION'
    | 'NOT_HAS_WEBINAR_REGISTRATION'
    | 'HAS_WEBINAR_ATTENDANCE'
    | 'NOT_HAS_WEBINAR_ATTENDANCE'
    | unhandledEnumCase;
}

export type FieldLevelPermission = { accessLevel: string };

export type SensitiveDataCategory = 'HIPAA' | unhandledEnumCase;

export type MaskedSubstring = { start?: number; end?: number; label?: string };

export type MaskedSubstrings = { substrings: Default<MaskedSubstring[]> };

export type PropertyFieldType =
  | 'booleancheckbox'
  | 'checkbox'
  | 'date'
  | 'file'
  | 'number'
  | 'phonenumber'
  | 'radio'
  | 'select'
  | 'text'
  | 'textarea'
  | 'calculation_equation'
  | 'calculation_rollup'
  | 'calculation_score'
  | 'calculation_read_time'
  | 'unknown'
  | 'html'
  | unhandledEnumCase;

export type PropertySource =
  | 'UNKNOWN'
  | 'IMPORT'
  | 'API'
  | 'FORM'
  | 'ANALYTICS'
  | 'MIGRATION'
  | 'SALESFORCE'
  | 'INTEGRATION'
  | 'CONTACTS_WEB'
  | 'WAL_INCREMENTAL'
  | 'TASK'
  | 'EMAIL'
  | 'WORKFLOWS'
  | 'CALCULATED'
  | 'SOCIAL'
  | 'BATCH_UPDATE'
  | 'SIGNALS'
  | 'BIDEN'
  | 'DEFAULT'
  | 'COMPANIES'
  | 'DEALS'
  | 'ASSISTS'
  | 'PRESENTATIONS'
  | 'TALLY'
  | 'SIDEKICK'
  | 'CRM_UI'
  | 'MERGE_CONTACTS'
  | 'PORTAL_USER_ASSOCIATOR'
  | 'INTEGRATIONS_PLATFORM'
  | 'BCC_TO_CRM'
  | 'FORWARD_TO_CRM'
  | 'ENGAGEMENTS'
  | 'SALES'
  | 'HEISENBERG'
  | 'LEADIN'
  | 'GMAIL_INTEGRATION'
  | 'ACADEMY'
  | 'SALES_MESSAGES'
  | 'AVATARS_SERVICE'
  | 'MERGE_COMPANIES'
  | 'SEQUENCES'
  | 'COMPANY_FAMILIES'
  | 'MOBILE_IOS'
  | 'MOBILE_ANDROID'
  | 'CONTACTS'
  | 'ASSOCIATIONS'
  | 'EXTENSION'
  | 'SUCCESS'
  | 'BOT'
  | 'INTEGRATIONS_SYNC'
  | 'AUTOMATION_PLATFORM'
  | 'CONVERSATIONS'
  | 'EMAIL_INTEGRATION'
  | 'CONTENT_MEMBERSHIP'
  | 'QUOTES'
  | 'BET_ASSIGNMENT'
  | 'QUOTAS'
  | 'BET_CRM_CONNECTOR'
  | 'MEETINGS'
  | 'MERGE_OBJECTS'
  | 'RECYCLING_BIN'
  | 'ADS'
  | 'AI_GROUP'
  | 'COMMUNICATOR'
  | 'SETTINGS'
  | 'PROPERTY_SETTINGS'
  | 'PIPELINE_SETTINGS'
  | 'COMPANY_INSIGHTS'
  | 'BEHAVIORAL_EVENTS'
  | 'PAYMENTS'
  | 'GOALS'
  | 'PORTAL_OBJECT_SYNC'
  | 'APPROVALS'
  | 'FILE_MANAGER'
  | 'MARKETPLACE'
  | 'INTERNAL_PROCESSING'
  | 'FORECASTING'
  | 'SLACK_INTEGRATION'
  | 'CRM_UI_BULK_ACTION'
  | 'WORKFLOW_CONTACT_DELETE_ACTION'
  | 'ACCEPTANCE_TEST'
  | 'PLAYBOOKS'
  | 'CHATSPOT'
  | 'FLYWHEEL_PRODUCT_DATA_SYNC'
  | 'HELP_DESK'
  | 'BILLING'
  | 'DATA_ENRICHMENT'
  | 'AUTOMATION_JOURNEY'
  | 'MICROAPPS'
  | 'INTENT'
  | 'PROSPECTING_AGENT'
  | 'CENTRAL_EXCHANGE_RATES'
  | 'HELP_DESK_AI'
  | 'CONVERSATIONAL_ENRICHMENT'
  | 'CRM_PROCESSES_PLATFORM'
  | 'CLONE_OBJECTS'
  | 'MARKET_SOURCING'
  | 'DATASET'
  | 'PROPERTY_RESTORE'
  | 'EMAIL_INBOX_IMPORT'
  | 'CUSTOMER_AGENT'
  | 'LEGAL_BASIS_REMEDIATION'
  | 'AUTO_ASSOCIATE_BY_DOMAIN'
  | 'ACTIVITY_AUTO_ASSOCIATE'
  | 'PRIMARY_AUTOMATION'
  | 'DELETE_OBJECTS'
  | 'RESTORE_OBJECTS'
  | 'WORK_UI'
  | 'PROPERTY_DEFAULT_VALUE'
  | 'MERGE_REVERT_OBJECTS'
  | 'SMART_DATA_CAPTURE'
  | 'ACTIVITY_LOG_REVERT'
  | 'DATA_QUALITY'
  | 'REVENUE_PLATFORM'
  | 'MARKETS'
  | 'CONNECTED_ACCOUNT'
  | 'BREEZE_AGENT'
  | 'DI_WRITE_TO_CRM'
  | 'CUSTOMER_PORTAL'
  | unhandledEnumCase;

export type PropertyValue = {
  sourceId?: string;
  sourceLabel?: string;
  sourceUpstreamDeployable?: string;
  source?: PropertySource;
  updatedByUserId?: number;
  sourceMetadata?: string;
  requestId?: string;
  isEncrypted?: boolean;
  value?: string;
  maskedSubstrings?: MaskedSubstrings;
  selectedByUserTimestamp?: number;
  timestamp?: number;
  selectedByUser?: boolean;
  persistenceTimestamp?: number;
  dataSensitivity?: SensitivityLevel;
  unit?: string;
  sourceVid: Default<number[]>;
  name?: string;
  useTimestampAsPersistenceTimestamp?: boolean;
  isLargeValue?: boolean;
};

export type SensitivityLevel = 'none' | 'standard' | 'high' | unhandledEnumCase;

export namespace ComHubspotSubscriptionsCoreStatus {
  export type OptState =
    | 'DOUBLE_OPT_IN'
    | 'OPT_IN'
    | 'OPT_OUT'
    | 'NOT_OPTED'
    | unhandledEnumCase;
}

export type Channel = 'EMAIL' | 'WHATSAPP' | 'SMS' | unhandledEnumCase;

export type ApiKeyLocation = 'HEADER' | 'QUERY_PARAM' | unhandledEnumCase;

export type ApiKeySettings = {
  secretName: string;
  name: string;
  location: ApiKeyLocation;
};

export const ActionConfigurationDiscriminantKey = 'configurationType';
export type ActionConfiguration = CustomCodeConfiguration;

export const CustomCodeConfigurationTypename =
  'com.hubspot.workflows.models.configuration.CustomCodeConfiguration';
export const CustomCodeConfigurationDiscriminant = 'CUSTOM_CODE';
export const CustomCodeConfigurationDiscriminantKey = 'configurationType';
export type CustomCodeConfiguration = {
  sourceCode?: string;
  packageId?: number;
  runtime?: ActionFunctionRuntime;
  secrets: Default<string[]>;
  __typename: 'com.hubspot.workflows.models.configuration.CustomCodeConfiguration';
} & { configurationType?: 'CUSTOM_CODE' };

export type CustomInputType =
  | 'TEXT'
  | 'NUMBER'
  | 'CHECKBOX'
  | 'RECORD'
  | unhandledEnumCase;

export type NodeType = 'ACTION' | 'TRIGGER' | 'STICKY_NOTE' | unhandledEnumCase;

export type RunBehavior = 'ONCE' | 'EVERY_TIME' | unhandledEnumCase;

export type RunSettings = {
  runBehavior: RunBehavior;
  unenrollmentSettings?: UnenrollmentSettings;
  allowRunsFromRecordMerge: Default<boolean>;
};

export type StickyNote = { text: string };

export type Trigger = {
  id: string;
  objectTypeId?: string;
  requiredFilter?: FilterBranch;
  additionalFilter?: FilterBranch;
  customInputs: Default<TriggerCustomInput[]>;
};

export type TriggerCriteria = {
  triggers: Default<Trigger[]>;
  runSettings?: RunSettings;
};

export type TriggerCustomInput = {
  id?: string;
  name: string;
  type: CustomInputType;
  objectTypeId?: string;
  required: Default<boolean>;
};

export type UnenrollmentSettings = {
  unenrollWhenCriteriaNotMet?: boolean;
  exclusionCriteria?: FilterBranch;
};

export type DisplaySettingsResponse = {
  nodes: Default<Record<string, NodeDisplaySettingsResponse>>;
};

export type NodeDisplaySettingsResponse = {
  nodeLabel?: string;
  x: number;
  y: number;
  defaultNodeLabel: string;
  nodeType: Default<NodeType>;
};

export type WorkflowResponse = {
  actions: Default<Record<string, Action>>;
  actionConfigurations: Default<Record<string, ActionConfiguration>>;
  description?: string;
  displaySettings?: DisplaySettingsResponse;
  firstExecutionActionId?: number;
  name?: string;
  nextAvailableActionId: number;
  revisionNumber: number;
  stickyNotes: Default<Record<string, StickyNote>>;
  nextAvailableStickyNoteId: Default<number>;
  triggerCriteria?: TriggerCriteria;
  workflowId: number;
};

export type DayOfWeek =
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | unhandledEnumCase;

export namespace JavaTime {
  export type Month =
    | 'JANUARY'
    | 'FEBRUARY'
    | 'MARCH'
    | 'APRIL'
    | 'MAY'
    | 'JUNE'
    | 'JULY'
    | 'AUGUST'
    | 'SEPTEMBER'
    | 'OCTOBER'
    | 'NOVEMBER'
    | 'DECEMBER'
    | unhandledEnumCase;
}

export type ChronoUnit =
  | 'NANOS'
  | 'MICROS'
  | 'MILLIS'
  | 'SECONDS'
  | 'MINUTES'
  | 'HOURS'
  | 'HALF_DAYS'
  | 'DAYS'
  | 'WEEKS'
  | 'MONTHS'
  | 'YEARS'
  | 'DECADES'
  | 'CENTURIES'
  | 'MILLENNIA'
  | 'ERAS'
  | 'FOREVER'
  | unhandledEnumCase;

export type FetchAllowedActionTypesRequestType =
  Requestify<FetchAllowedActionTypesRequest>;
export type FetchAllowedActionTypesResponseType =
  FetchAllowedActionTypesResponse;
export type FetchAllowedActionTypesErrorType = EmptyError & HubspotMetadata;
export const fetchAllowedActionTypesRpc: ChirpAvroRpcDetails<
  FetchAllowedActionTypesRequestType,
  FetchAllowedActionTypesResponseType,
  FetchAllowedActionTypesErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2',
  rpcName: 'fetchAllowedActionTypes',
  auth: 'app',
  fingerprint: 'cFM4Rh7uO9Q6MaZmJ9udrZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchAllowedTriggersRequestType =
  Requestify<FetchAllowedTriggersRequest>;
export type FetchAllowedTriggersResponseType = FetchAllowedTriggersResponse;
export type FetchAllowedTriggersErrorType = EmptyError & HubspotMetadata;
export const fetchAllowedTriggersRpc: ChirpAvroRpcDetails<
  FetchAllowedTriggersRequestType,
  FetchAllowedTriggersResponseType,
  FetchAllowedTriggersErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2',
  rpcName: 'fetchAllowedTriggers',
  auth: 'app',
  fingerprint: 'TBBMvv0mE5VyQp4e0GSqLZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchPermissionsRequestType = Requestify<FetchPermissionsRequest>;
export type FetchPermissionsResponseType = FetchPermissionsResponse;
export type FetchPermissionsErrorType = EmptyError & HubspotMetadata;
export const fetchPermissionsRpc: ChirpAvroRpcDetails<
  FetchPermissionsRequestType,
  FetchPermissionsResponseType,
  FetchPermissionsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2',
  rpcName: 'fetchPermissions',
  auth: 'app',
  fingerprint: 'AdUZYmrRs1j0Tjh773Vlq5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchEmbeddedSummaryRequestType =
  Requestify<FetchEmbeddedSummaryRequest>;
export type FetchEmbeddedSummaryResponseType = FetchEmbeddedSummaryResponse;
export type FetchEmbeddedSummaryErrorType = FetchEmbeddedSummaryError &
  HubspotMetadata;
export const fetchEmbeddedSummaryRpc: ChirpAvroRpcDetails<
  FetchEmbeddedSummaryRequestType,
  FetchEmbeddedSummaryResponseType,
  FetchEmbeddedSummaryErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2',
  rpcName: 'fetchEmbeddedSummary',
  auth: 'app',
  fingerprint: '9ju4ll8zORu0EwuwzPEitAEsrR_GVYu6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchRelatedAutomationsRequestType =
  Requestify<FetchRelatedAutomationsRequest>;
export type FetchRelatedAutomationsResponseType =
  FetchRelatedAutomationsResponse;
export type FetchRelatedAutomationsErrorType = FetchRelatedAutomationsError &
  HubspotMetadata;
export const fetchRelatedAutomationsRpc: ChirpAvroRpcDetails<
  FetchRelatedAutomationsRequestType,
  FetchRelatedAutomationsResponseType,
  FetchRelatedAutomationsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2',
  rpcName: 'fetchRelatedAutomations',
  auth: 'app',
  fingerprint: 'L83I5y6bvOF_ILxbh3zZQ7dlkt4qvv1k',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchAllAutomationsRequestType =
  Requestify<FetchAllAutomationsRequest>;
export type FetchAllAutomationsResponseType = FetchAllAutomationsResponse;
export type FetchAllAutomationsErrorType = FetchAllAutomationsError &
  HubspotMetadata;
export const fetchAllAutomationsRpc: ChirpAvroRpcDetails<
  FetchAllAutomationsRequestType,
  FetchAllAutomationsResponseType,
  FetchAllAutomationsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2',
  rpcName: 'fetchAllAutomations',
  auth: 'app',
  fingerprint: '3ZmC7O8qq3WrcRSdpbHdm28ZaywmK1vN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SearchRelatedAutomationsRequestType =
  Requestify<SearchRelatedAutomationsRequest>;
export type SearchRelatedAutomationsResponseType =
  SearchRelatedAutomationsResponse;
export type SearchRelatedAutomationsErrorType = SearchRelatedAutomationsError &
  HubspotMetadata;
export const searchRelatedAutomationsRpc: ChirpAvroRpcDetails<
  SearchRelatedAutomationsRequestType,
  SearchRelatedAutomationsResponseType,
  SearchRelatedAutomationsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2',
  rpcName: 'searchRelatedAutomations',
  auth: 'app',
  fingerprint: 'cbB6t2NsV8mFpuok27dz7-NAfwEdAw9Z',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchTemplatesRequestType = Requestify<FetchTemplatesRequest>;
export type FetchTemplatesResponseType = FetchTemplatesResponse;
export type FetchTemplatesErrorType = FetchTemplatesError & HubspotMetadata;
export const fetchTemplatesRpc: ChirpAvroRpcDetails<
  FetchTemplatesRequestType,
  FetchTemplatesResponseType,
  FetchTemplatesErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2',
  rpcName: 'fetchTemplates',
  auth: 'app',
  fingerprint: 'tx9Td0QXVKm_NOWJ9aCuJZa22E4173vi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchWorkflowRequestType = Requestify<FetchWorkflowRequest>;
export type FetchWorkflowResponseType = FetchWorkflowResponse;
export type FetchWorkflowErrorType = FetchWorkflowError & HubspotMetadata;
export const fetchWorkflowRpc: ChirpAvroRpcDetails<
  FetchWorkflowRequestType,
  FetchWorkflowResponseType,
  FetchWorkflowErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2',
  rpcName: 'fetchWorkflow',
  auth: 'app',
  fingerprint: 'LjY_ajLsKjtMfJd7Q8c411ho0lIJK6SL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ResolveWorkflowLinksRequestType =
  Requestify<ResolveWorkflowLinksRequest>;
export type ResolveWorkflowLinksResponseType = ResolveWorkflowLinksResponse;
export type ResolveWorkflowLinksErrorType = ResolveWorkflowLinksError &
  HubspotMetadata;
export const resolveWorkflowLinksRpc: ChirpAvroRpcDetails<
  ResolveWorkflowLinksRequestType,
  ResolveWorkflowLinksResponseType,
  ResolveWorkflowLinksErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2',
  rpcName: 'resolveWorkflowLinks',
  auth: 'app',
  fingerprint: '1iIDHfVJlIHnAxZzkrgF-kjsGEjl6_Lv',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
